var an = Object.defineProperty;
var on = (n, t, e) => t in n ? an(n, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : n[t] = e;
var Y = (n, t, e) => on(n, typeof t != "symbol" ? t + "" : t, e);
import { useRef as sn, useLayoutEffect as un, useCallback as ce, useEffect as Et, useState as fe, createContext as cn, useContext as fn } from "react";
import { jsx as ln } from "react/jsx-runtime";
class hn {
  constructor() {
    this.logMessage("Environment Variables", process.env);
  }
  /**
   * Method for returning if the app is running in the production
   * environment. The production environment is determined by a
   * couple different things. First, there is an environment variable
   * named MCHS_PRODUCTION_BUILD that should be set to define if
   * the environment is production. If, for some reason, that variable
   * is not set, then the fallback is to use the NODE_ENV variable.
   *
   * @returns Flag indicating if the app is a production build.
   */
  isProductionEnvironment() {
    return process.env.MCHS_PRODUCTION_BUILD ? process.env.MCHS_PRODUCTION_BUILD === "true" : process.env.NODE_ENV === "production";
  }
  isTestEnvironment() {
    return process.env.NODE_ENV === "test";
  }
  isDevelopmentEnvironment() {
    return !(this.isProductionEnvironment() || this.isTestEnvironment());
  }
  /**
   * Method for returning the service call latency in the number
   * of milliseconds.  This value is used for the development
   * environment.  For other environments, this method will always
   * return 0.
   *
   * @returns The service call latency in milliseconds.
   */
  serviceCallLatency() {
    let t = 0;
    return this.isDevelopmentEnvironment() || this.isTestEnvironment() ? t = process.env.MCHS_SERVICE_CALL_LATENCY && parseInt(process.env.MCHS_SERVICE_CALL_LATENCY) || 0 : t = 0, t;
  }
  /**
   * Method for returning the service host name for the application service layer.
   *
   * @returns String containing the service host name.
   */
  serviceHostName() {
    return process.env.MCHS_SERVICE_HOST_NAME || this.logMessage(
      "The service host name is required, but is not set.  Please set an environment variable named MCHS_SERVICE_HOST_NAME."
    ), process.env.MCHS_SERVICE_HOST_NAME ?? "";
  }
  /**
   * Method for returning whether or not mock data is being used.  As a safety precaution,
   * if this is a production build this will always return false.
   *
   * @returns Boolean indicating if mock data is being used.
   */
  mockData() {
    return this.isProductionEnvironment() ? !1 : process.env.MCHS_MOCK_DATA === "true";
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  logMessage(t, ...e) {
    this.isDevelopmentEnvironment() && console.log("[mchs] ENVIRONMENT -> " + t, e);
  }
}
const bt = new hn();
Object.freeze(bt);
const fi = (n, t, e = null) => {
  const r = sn(t);
  un(() => {
    r.current = t;
  });
  const i = (s, l) => s.key === l.key ? !(l.altKey && !s.altKey || l.ctrlKey && !s.ctrlKey || l.shiftKey && !s.shiftKey) : !1, a = ce(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (s) => {
      const l = n.find((d) => i(s, d));
      l !== void 0 && (s.repeat || r.current(l), s.stopPropagation(), s.preventDefault());
    },
    [n]
  );
  Et(() => {
    const s = e ?? document;
    return s !== null && s.addEventListener("keydown", a), () => {
      s !== null && s.removeEventListener("keydown", a);
    };
  }, [a, e]);
}, li = (n, t) => {
  Et(() => {
    const e = (r) => {
      n.current && r.target instanceof HTMLElement && !n.current.contains(r.target) && t();
    };
    return document.addEventListener("mousedown", e), () => {
      document.removeEventListener("mousedown", e);
    };
  }, [n, t]);
}, hi = () => {
  const [n, t] = fe({
    width: window.innerWidth,
    height: window.innerHeight
  });
  return Et(() => {
    const e = () => {
      t({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };
    return window.addEventListener("resize", e), () => {
      window.removeEventListener("resize", e);
    };
  }, []), n;
};
function di(n) {
  const [t, e] = fe(n), r = ce(
    () => e(!t),
    [t]
  );
  return [t, r];
}
var Qt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
/*! *****************************************************************************
Copyright (C) Microsoft. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var Xt;
(function(n) {
  (function(t) {
    var e = typeof globalThis == "object" ? globalThis : typeof Qt == "object" ? Qt : typeof self == "object" ? self : typeof this == "object" ? this : l(), r = i(n);
    typeof e.Reflect < "u" && (r = i(e.Reflect, r)), t(r, e), typeof e.Reflect > "u" && (e.Reflect = n);
    function i(d, o) {
      return function(h, _) {
        Object.defineProperty(d, h, { configurable: !0, writable: !0, value: _ }), o && o(h, _);
      };
    }
    function a() {
      try {
        return Function("return this;")();
      } catch {
      }
    }
    function s() {
      try {
        return (0, eval)("(function() { return this; })()");
      } catch {
      }
    }
    function l() {
      return a() || s();
    }
  })(function(t, e) {
    var r = Object.prototype.hasOwnProperty, i = typeof Symbol == "function", a = i && typeof Symbol.toPrimitive < "u" ? Symbol.toPrimitive : "@@toPrimitive", s = i && typeof Symbol.iterator < "u" ? Symbol.iterator : "@@iterator", l = typeof Object.create == "function", d = { __proto__: [] } instanceof Array, o = !l && !d, h = {
      // create an object in dictionary mode (a.k.a. "slow" mode in v8)
      create: l ? function() {
        return _t(/* @__PURE__ */ Object.create(null));
      } : d ? function() {
        return _t({ __proto__: null });
      } : function() {
        return _t({});
      },
      has: o ? function(u, c) {
        return r.call(u, c);
      } : function(u, c) {
        return c in u;
      },
      get: o ? function(u, c) {
        return r.call(u, c) ? u[c] : void 0;
      } : function(u, c) {
        return u[c];
      }
    }, _ = Object.getPrototypeOf(Function), S = typeof Map == "function" && typeof Map.prototype.entries == "function" ? Map : Xe(), N = typeof Set == "function" && typeof Set.prototype.entries == "function" ? Set : tn(), x = typeof WeakMap == "function" ? WeakMap : en(), F = i ? Symbol.for("@reflect-metadata:registry") : void 0, W = Ze(), at = qe(W);
    function Pe(u, c, f, v) {
      if (b(f)) {
        if (!Gt(u))
          throw new TypeError();
        if (!Yt(c))
          throw new TypeError();
        return We(u, c);
      } else {
        if (!Gt(u))
          throw new TypeError();
        if (!E(c))
          throw new TypeError();
        if (!E(v) && !b(v) && !K(v))
          throw new TypeError();
        return K(v) && (v = void 0), f = $(f), Ve(u, c, f, v);
      }
    }
    t("decorate", Pe);
    function Re(u, c) {
      function f(v, w) {
        if (!E(v))
          throw new TypeError();
        if (!b(w) && !ze(w))
          throw new TypeError();
        Lt(u, c, v, w);
      }
      return f;
    }
    t("metadata", Re);
    function xe(u, c, f, v) {
      if (!E(f))
        throw new TypeError();
      return b(v) || (v = $(v)), Lt(u, c, f, v);
    }
    t("defineMetadata", xe);
    function Fe(u, c, f) {
      if (!E(c))
        throw new TypeError();
      return b(f) || (f = $(f)), kt(u, c, f);
    }
    t("hasMetadata", Fe);
    function ke(u, c, f) {
      if (!E(c))
        throw new TypeError();
      return b(f) || (f = $(f)), gt(u, c, f);
    }
    t("hasOwnMetadata", ke);
    function Be(u, c, f) {
      if (!E(c))
        throw new TypeError();
      return b(f) || (f = $(f)), Bt(u, c, f);
    }
    t("getMetadata", Be);
    function je(u, c, f) {
      if (!E(c))
        throw new TypeError();
      return b(f) || (f = $(f)), jt(u, c, f);
    }
    t("getOwnMetadata", je);
    function Le(u, c) {
      if (!E(u))
        throw new TypeError();
      return b(c) || (c = $(c)), Ut(u, c);
    }
    t("getMetadataKeys", Le);
    function Ue(u, c) {
      if (!E(u))
        throw new TypeError();
      return b(c) || (c = $(c)), $t(u, c);
    }
    t("getOwnMetadataKeys", Ue);
    function $e(u, c, f) {
      if (!E(c))
        throw new TypeError();
      if (b(f) || (f = $(f)), !E(c))
        throw new TypeError();
      b(f) || (f = $(f));
      var v = Z(
        c,
        f,
        /*Create*/
        !1
      );
      return b(v) ? !1 : v.OrdinaryDeleteMetadata(u, c, f);
    }
    t("deleteMetadata", $e);
    function We(u, c) {
      for (var f = u.length - 1; f >= 0; --f) {
        var v = u[f], w = v(c);
        if (!b(w) && !K(w)) {
          if (!Yt(w))
            throw new TypeError();
          c = w;
        }
      }
      return c;
    }
    function Ve(u, c, f, v) {
      for (var w = u.length - 1; w >= 0; --w) {
        var P = u[w], O = P(c, f, v);
        if (!b(O) && !K(O)) {
          if (!E(O))
            throw new TypeError();
          v = O;
        }
      }
      return v;
    }
    function kt(u, c, f) {
      var v = gt(u, c, f);
      if (v)
        return !0;
      var w = mt(c);
      return K(w) ? !1 : kt(u, w, f);
    }
    function gt(u, c, f) {
      var v = Z(
        c,
        f,
        /*Create*/
        !1
      );
      return b(v) ? !1 : Vt(v.OrdinaryHasOwnMetadata(u, c, f));
    }
    function Bt(u, c, f) {
      var v = gt(u, c, f);
      if (v)
        return jt(u, c, f);
      var w = mt(c);
      if (!K(w))
        return Bt(u, w, f);
    }
    function jt(u, c, f) {
      var v = Z(
        c,
        f,
        /*Create*/
        !1
      );
      if (!b(v))
        return v.OrdinaryGetOwnMetadata(u, c, f);
    }
    function Lt(u, c, f, v) {
      var w = Z(
        f,
        v,
        /*Create*/
        !0
      );
      w.OrdinaryDefineOwnMetadata(u, c, f, v);
    }
    function Ut(u, c) {
      var f = $t(u, c), v = mt(u);
      if (v === null)
        return f;
      var w = Ut(v, c);
      if (w.length <= 0)
        return f;
      if (f.length <= 0)
        return w;
      for (var P = new N(), O = [], A = 0, p = f; A < p.length; A++) {
        var g = p[A], y = P.has(g);
        y || (P.add(g), O.push(g));
      }
      for (var m = 0, D = w; m < D.length; m++) {
        var g = D[m], y = P.has(g);
        y || (P.add(g), O.push(g));
      }
      return O;
    }
    function $t(u, c) {
      var f = Z(
        u,
        c,
        /*create*/
        !1
      );
      return f ? f.OrdinaryOwnMetadataKeys(u, c) : [];
    }
    function Wt(u) {
      if (u === null)
        return 1;
      switch (typeof u) {
        case "undefined":
          return 0;
        case "boolean":
          return 2;
        case "string":
          return 3;
        case "symbol":
          return 4;
        case "number":
          return 5;
        case "object":
          return u === null ? 1 : 6;
        default:
          return 6;
      }
    }
    function b(u) {
      return u === void 0;
    }
    function K(u) {
      return u === null;
    }
    function Ge(u) {
      return typeof u == "symbol";
    }
    function E(u) {
      return typeof u == "object" ? u !== null : typeof u == "function";
    }
    function Ye(u, c) {
      switch (Wt(u)) {
        case 0:
          return u;
        case 1:
          return u;
        case 2:
          return u;
        case 3:
          return u;
        case 4:
          return u;
        case 5:
          return u;
      }
      var f = "string", v = Ht(u, a);
      if (v !== void 0) {
        var w = v.call(u, f);
        if (E(w))
          throw new TypeError();
        return w;
      }
      return He(u);
    }
    function He(u, c) {
      var f, v;
      {
        var w = u.toString;
        if (ot(w)) {
          var v = w.call(u);
          if (!E(v))
            return v;
        }
        var f = u.valueOf;
        if (ot(f)) {
          var v = f.call(u);
          if (!E(v))
            return v;
        }
      }
      throw new TypeError();
    }
    function Vt(u) {
      return !!u;
    }
    function Ke(u) {
      return "" + u;
    }
    function $(u) {
      var c = Ye(u);
      return Ge(c) ? c : Ke(c);
    }
    function Gt(u) {
      return Array.isArray ? Array.isArray(u) : u instanceof Object ? u instanceof Array : Object.prototype.toString.call(u) === "[object Array]";
    }
    function ot(u) {
      return typeof u == "function";
    }
    function Yt(u) {
      return typeof u == "function";
    }
    function ze(u) {
      switch (Wt(u)) {
        case 3:
          return !0;
        case 4:
          return !0;
        default:
          return !1;
      }
    }
    function yt(u, c) {
      return u === c || u !== u && c !== c;
    }
    function Ht(u, c) {
      var f = u[c];
      if (f != null) {
        if (!ot(f))
          throw new TypeError();
        return f;
      }
    }
    function Kt(u) {
      var c = Ht(u, s);
      if (!ot(c))
        throw new TypeError();
      var f = c.call(u);
      if (!E(f))
        throw new TypeError();
      return f;
    }
    function zt(u) {
      return u.value;
    }
    function Jt(u) {
      var c = u.next();
      return c.done ? !1 : c;
    }
    function Zt(u) {
      var c = u.return;
      c && c.call(u);
    }
    function mt(u) {
      var c = Object.getPrototypeOf(u);
      if (typeof u != "function" || u === _ || c !== _)
        return c;
      var f = u.prototype, v = f && Object.getPrototypeOf(f);
      if (v == null || v === Object.prototype)
        return c;
      var w = v.constructor;
      return typeof w != "function" || w === u ? c : w;
    }
    function Je() {
      var u;
      !b(F) && typeof e.Reflect < "u" && !(F in e.Reflect) && typeof e.Reflect.defineMetadata == "function" && (u = Qe(e.Reflect));
      var c, f, v, w = new x(), P = {
        registerProvider: O,
        getProvider: p,
        setProvider: y
      };
      return P;
      function O(m) {
        if (!Object.isExtensible(P))
          throw new Error("Cannot add provider to a frozen registry.");
        switch (!0) {
          case u === m:
            break;
          case b(c):
            c = m;
            break;
          case c === m:
            break;
          case b(f):
            f = m;
            break;
          case f === m:
            break;
          default:
            v === void 0 && (v = new N()), v.add(m);
            break;
        }
      }
      function A(m, D) {
        if (!b(c)) {
          if (c.isProviderFor(m, D))
            return c;
          if (!b(f)) {
            if (f.isProviderFor(m, D))
              return c;
            if (!b(v))
              for (var T = Kt(v); ; ) {
                var M = Jt(T);
                if (!M)
                  return;
                var U = zt(M);
                if (U.isProviderFor(m, D))
                  return Zt(T), U;
              }
          }
        }
        if (!b(u) && u.isProviderFor(m, D))
          return u;
      }
      function p(m, D) {
        var T = w.get(m), M;
        return b(T) || (M = T.get(D)), b(M) && (M = A(m, D), b(M) || (b(T) && (T = new S(), w.set(m, T)), T.set(D, M))), M;
      }
      function g(m) {
        if (b(m))
          throw new TypeError();
        return c === m || f === m || !b(v) && v.has(m);
      }
      function y(m, D, T) {
        if (!g(T))
          throw new Error("Metadata provider not registered.");
        var M = p(m, D);
        if (M !== T) {
          if (!b(M))
            return !1;
          var U = w.get(m);
          b(U) && (U = new S(), w.set(m, U)), U.set(D, T);
        }
        return !0;
      }
    }
    function Ze() {
      var u;
      return !b(F) && E(e.Reflect) && Object.isExtensible(e.Reflect) && (u = e.Reflect[F]), b(u) && (u = Je()), !b(F) && E(e.Reflect) && Object.isExtensible(e.Reflect) && Object.defineProperty(e.Reflect, F, {
        enumerable: !1,
        configurable: !1,
        writable: !1,
        value: u
      }), u;
    }
    function qe(u) {
      var c = new x(), f = {
        isProviderFor: function(g, y) {
          var m = c.get(g);
          return b(m) ? !1 : m.has(y);
        },
        OrdinaryDefineOwnMetadata: O,
        OrdinaryHasOwnMetadata: w,
        OrdinaryGetOwnMetadata: P,
        OrdinaryOwnMetadataKeys: A,
        OrdinaryDeleteMetadata: p
      };
      return W.registerProvider(f), f;
      function v(g, y, m) {
        var D = c.get(g), T = !1;
        if (b(D)) {
          if (!m)
            return;
          D = new S(), c.set(g, D), T = !0;
        }
        var M = D.get(y);
        if (b(M)) {
          if (!m)
            return;
          if (M = new S(), D.set(y, M), !u.setProvider(g, y, f))
            throw D.delete(y), T && c.delete(g), new Error("Wrong provider for target.");
        }
        return M;
      }
      function w(g, y, m) {
        var D = v(
          y,
          m,
          /*Create*/
          !1
        );
        return b(D) ? !1 : Vt(D.has(g));
      }
      function P(g, y, m) {
        var D = v(
          y,
          m,
          /*Create*/
          !1
        );
        if (!b(D))
          return D.get(g);
      }
      function O(g, y, m, D) {
        var T = v(
          m,
          D,
          /*Create*/
          !0
        );
        T.set(g, y);
      }
      function A(g, y) {
        var m = [], D = v(
          g,
          y,
          /*Create*/
          !1
        );
        if (b(D))
          return m;
        for (var T = D.keys(), M = Kt(T), U = 0; ; ) {
          var qt = Jt(M);
          if (!qt)
            return m.length = U, m;
          var nn = zt(qt);
          try {
            m[U] = nn;
          } catch (rn) {
            try {
              Zt(M);
            } finally {
              throw rn;
            }
          }
          U++;
        }
      }
      function p(g, y, m) {
        var D = v(
          y,
          m,
          /*Create*/
          !1
        );
        if (b(D) || !D.delete(g))
          return !1;
        if (D.size === 0) {
          var T = c.get(y);
          b(T) || (T.delete(m), T.size === 0 && c.delete(T));
        }
        return !0;
      }
    }
    function Qe(u) {
      var c = u.defineMetadata, f = u.hasOwnMetadata, v = u.getOwnMetadata, w = u.getOwnMetadataKeys, P = u.deleteMetadata, O = new x(), A = {
        isProviderFor: function(p, g) {
          var y = O.get(p);
          return !b(y) && y.has(g) ? !0 : w(p, g).length ? (b(y) && (y = new N(), O.set(p, y)), y.add(g), !0) : !1;
        },
        OrdinaryDefineOwnMetadata: c,
        OrdinaryHasOwnMetadata: f,
        OrdinaryGetOwnMetadata: v,
        OrdinaryOwnMetadataKeys: w,
        OrdinaryDeleteMetadata: P
      };
      return A;
    }
    function Z(u, c, f) {
      var v = W.getProvider(u, c);
      if (!b(v))
        return v;
      if (f) {
        if (W.setProvider(u, c, at))
          return at;
        throw new Error("Illegal state.");
      }
    }
    function Xe() {
      var u = {}, c = [], f = (
        /** @class */
        function() {
          function A(p, g, y) {
            this._index = 0, this._keys = p, this._values = g, this._selector = y;
          }
          return A.prototype["@@iterator"] = function() {
            return this;
          }, A.prototype[s] = function() {
            return this;
          }, A.prototype.next = function() {
            var p = this._index;
            if (p >= 0 && p < this._keys.length) {
              var g = this._selector(this._keys[p], this._values[p]);
              return p + 1 >= this._keys.length ? (this._index = -1, this._keys = c, this._values = c) : this._index++, { value: g, done: !1 };
            }
            return { value: void 0, done: !0 };
          }, A.prototype.throw = function(p) {
            throw this._index >= 0 && (this._index = -1, this._keys = c, this._values = c), p;
          }, A.prototype.return = function(p) {
            return this._index >= 0 && (this._index = -1, this._keys = c, this._values = c), { value: p, done: !0 };
          }, A;
        }()
      ), v = (
        /** @class */
        function() {
          function A() {
            this._keys = [], this._values = [], this._cacheKey = u, this._cacheIndex = -2;
          }
          return Object.defineProperty(A.prototype, "size", {
            get: function() {
              return this._keys.length;
            },
            enumerable: !0,
            configurable: !0
          }), A.prototype.has = function(p) {
            return this._find(
              p,
              /*insert*/
              !1
            ) >= 0;
          }, A.prototype.get = function(p) {
            var g = this._find(
              p,
              /*insert*/
              !1
            );
            return g >= 0 ? this._values[g] : void 0;
          }, A.prototype.set = function(p, g) {
            var y = this._find(
              p,
              /*insert*/
              !0
            );
            return this._values[y] = g, this;
          }, A.prototype.delete = function(p) {
            var g = this._find(
              p,
              /*insert*/
              !1
            );
            if (g >= 0) {
              for (var y = this._keys.length, m = g + 1; m < y; m++)
                this._keys[m - 1] = this._keys[m], this._values[m - 1] = this._values[m];
              return this._keys.length--, this._values.length--, yt(p, this._cacheKey) && (this._cacheKey = u, this._cacheIndex = -2), !0;
            }
            return !1;
          }, A.prototype.clear = function() {
            this._keys.length = 0, this._values.length = 0, this._cacheKey = u, this._cacheIndex = -2;
          }, A.prototype.keys = function() {
            return new f(this._keys, this._values, w);
          }, A.prototype.values = function() {
            return new f(this._keys, this._values, P);
          }, A.prototype.entries = function() {
            return new f(this._keys, this._values, O);
          }, A.prototype["@@iterator"] = function() {
            return this.entries();
          }, A.prototype[s] = function() {
            return this.entries();
          }, A.prototype._find = function(p, g) {
            if (!yt(this._cacheKey, p)) {
              this._cacheIndex = -1;
              for (var y = 0; y < this._keys.length; y++)
                if (yt(this._keys[y], p)) {
                  this._cacheIndex = y;
                  break;
                }
            }
            return this._cacheIndex < 0 && g && (this._cacheIndex = this._keys.length, this._keys.push(p), this._values.push(void 0)), this._cacheIndex;
          }, A;
        }()
      );
      return v;
      function w(A, p) {
        return A;
      }
      function P(A, p) {
        return p;
      }
      function O(A, p) {
        return [A, p];
      }
    }
    function tn() {
      var u = (
        /** @class */
        function() {
          function c() {
            this._map = new S();
          }
          return Object.defineProperty(c.prototype, "size", {
            get: function() {
              return this._map.size;
            },
            enumerable: !0,
            configurable: !0
          }), c.prototype.has = function(f) {
            return this._map.has(f);
          }, c.prototype.add = function(f) {
            return this._map.set(f, f), this;
          }, c.prototype.delete = function(f) {
            return this._map.delete(f);
          }, c.prototype.clear = function() {
            this._map.clear();
          }, c.prototype.keys = function() {
            return this._map.keys();
          }, c.prototype.values = function() {
            return this._map.keys();
          }, c.prototype.entries = function() {
            return this._map.entries();
          }, c.prototype["@@iterator"] = function() {
            return this.keys();
          }, c.prototype[s] = function() {
            return this.keys();
          }, c;
        }()
      );
      return u;
    }
    function en() {
      var u = 16, c = h.create(), f = v();
      return (
        /** @class */
        function() {
          function p() {
            this._key = v();
          }
          return p.prototype.has = function(g) {
            var y = w(
              g,
              /*create*/
              !1
            );
            return y !== void 0 ? h.has(y, this._key) : !1;
          }, p.prototype.get = function(g) {
            var y = w(
              g,
              /*create*/
              !1
            );
            return y !== void 0 ? h.get(y, this._key) : void 0;
          }, p.prototype.set = function(g, y) {
            var m = w(
              g,
              /*create*/
              !0
            );
            return m[this._key] = y, this;
          }, p.prototype.delete = function(g) {
            var y = w(
              g,
              /*create*/
              !1
            );
            return y !== void 0 ? delete y[this._key] : !1;
          }, p.prototype.clear = function() {
            this._key = v();
          }, p;
        }()
      );
      function v() {
        var p;
        do
          p = "@@WeakMap@@" + A();
        while (h.has(c, p));
        return c[p] = !0, p;
      }
      function w(p, g) {
        if (!r.call(p, f)) {
          if (!g)
            return;
          Object.defineProperty(p, f, { value: h.create() });
        }
        return p[f];
      }
      function P(p, g) {
        for (var y = 0; y < g; ++y)
          p[y] = Math.random() * 255 | 0;
        return p;
      }
      function O(p) {
        if (typeof Uint8Array == "function") {
          var g = new Uint8Array(p);
          return typeof crypto < "u" ? crypto.getRandomValues(g) : typeof msCrypto < "u" ? msCrypto.getRandomValues(g) : P(g, p), g;
        }
        return P(new Array(p), p);
      }
      function A() {
        var p = O(u);
        p[6] = p[6] & 79 | 64, p[8] = p[8] & 191 | 128;
        for (var g = "", y = 0; y < u; ++y) {
          var m = p[y];
          (y === 4 || y === 6 || y === 8) && (g += "-"), m < 16 && (g += "0"), g += m.toString(16).toLowerCase();
        }
        return g;
      }
    }
    function _t(u) {
      return u.__ = void 0, delete u.__, u;
    }
  });
})(Xt || (Xt = {}));
var L = "named", le = "name", Ot = "unmanaged", he = "optional", Nt = "inject", tt = "multi_inject", dn = "inversify:tagged", vn = "inversify:tagged_props", At = "inversify:paramtypes", pn = "design:paramtypes", te = "post_construct", Dt = "pre_destroy";
function gn() {
  return [
    Nt,
    tt,
    le,
    Ot,
    L,
    he
  ];
}
var ee = gn(), C = {
  Request: "Request",
  Singleton: "Singleton",
  Transient: "Transient"
}, I = {
  ConstantValue: "ConstantValue",
  Constructor: "Constructor",
  DynamicValue: "DynamicValue",
  Factory: "Factory",
  Function: "Function",
  Instance: "Instance",
  Invalid: "Invalid",
  Provider: "Provider"
}, rt = {
  ClassProperty: "ClassProperty",
  ConstructorArgument: "ConstructorArgument",
  Variable: "Variable"
}, yn = 0;
function it() {
  return yn++;
}
var mn = function() {
  function n(t, e) {
    this.id = it(), this.activated = !1, this.serviceIdentifier = t, this.scope = e, this.type = I.Invalid, this.constraint = function(r) {
      return !0;
    }, this.implementationType = null, this.cache = null, this.factory = null, this.provider = null, this.onActivation = null, this.onDeactivation = null, this.dynamicValue = null;
  }
  return n.prototype.clone = function() {
    var t = new n(this.serviceIdentifier, this.scope);
    return t.activated = t.scope === C.Singleton ? this.activated : !1, t.implementationType = this.implementationType, t.dynamicValue = this.dynamicValue, t.scope = this.scope, t.type = this.type, t.factory = this.factory, t.provider = this.provider, t.constraint = this.constraint, t.onActivation = this.onActivation, t.onDeactivation = this.onDeactivation, t.cache = this.cache, t;
  }, n;
}(), _n = "Cannot apply @injectable decorator multiple times.", q = "NULL argument", ne = "Key Not Found", wn = "Ambiguous match found for serviceIdentifier:", bn = "Could not unbind serviceIdentifier:", An = "No matching bindings found for serviceIdentifier:", de = "Missing required @injectable annotation in:", Dn = "Missing required @inject or @multiInject annotation in:", Sn = "Circular dependency found:", Tn = "Invalid binding type:", In = "No snapshot available to restore.", Mn = "Invalid return type in middleware. Middleware must return!", Cn = "Value provided to function binding must be a function!", En = function(n) {
  return "You are attempting to construct '" + n + `' in a synchronous way
 but it has asynchronous dependencies.`;
}, On = "The toSelf function can only be applied when a constructor is used as service identifier", Nn = function() {
  for (var n = [], t = 0; t < arguments.length; t++)
    n[t] = arguments[t];
  return "The number of constructor arguments in the derived class " + (n[0] + " must be >= than the number of constructor arguments of its base class.");
}, Pn = "Invalid Container constructor argument. Container options must be an object.", Rn = 'Invalid Container option. Default scope must be a string ("singleton" or "transient").', xn = "Invalid Container option. Auto bind injectable must be a boolean", Fn = "Invalid Container option. Skip base check must be a boolean", kn = "Attempting to unbind dependency with asynchronous destruction (@preDestroy or onDeactivation)", Bn = function(n, t) {
  return "@postConstruct error in class " + n + ": " + t;
}, jn = function(n, t) {
  return "@preDestroy error in class " + n + ": " + t;
}, St = function(n, t) {
  return "onDeactivation() error in class " + n + ": " + t;
}, Ln = function(n, t) {
  return "It looks like there is a circular dependency in one of the '" + n + "' bindings. Please investigate bindings with " + ("service identifier '" + t + "'.");
}, Un = "Maximum call stack size exceeded", $n = function() {
  function n() {
  }
  return n.prototype.getConstructorMetadata = function(t) {
    var e = Reflect.getMetadata(At, t), r = Reflect.getMetadata(dn, t);
    return {
      compilerGeneratedMetadata: e,
      userGeneratedMetadata: r || {}
    };
  }, n.prototype.getPropertiesMetadata = function(t) {
    var e = Reflect.getMetadata(vn, t) || [];
    return e;
  }, n;
}(), ut = {
  MultipleBindingsAvailable: 2,
  NoBindingsAvailable: 0,
  OnlyOneBindingAvailable: 1
};
function ve(n) {
  return n instanceof RangeError || n.message === Un;
}
var Wn = function(n, t) {
  try {
    return n();
  } catch (e) {
    throw ve(e) && (e = t()), e;
  }
};
function et(n) {
  if (typeof n == "function") {
    var t = n;
    return t.name;
  } else {
    if (typeof n == "symbol")
      return n.toString();
    var t = n;
    return t;
  }
}
function re(n, t, e) {
  var r = "", i = e(n, t);
  return i.length !== 0 && (r = `
Registered bindings:`, i.forEach(function(a) {
    var s = "Object";
    a.implementationType !== null && (s = vt(a.implementationType)), r = r + `
 ` + s, a.constraint.metaData && (r = r + " - " + a.constraint.metaData);
  })), r;
}
function pe(n, t) {
  return n.parentRequest === null ? !1 : n.parentRequest.serviceIdentifier === t ? !0 : pe(n.parentRequest, t);
}
function Vn(n) {
  function t(r, i) {
    i === void 0 && (i = []);
    var a = et(r.serviceIdentifier);
    return i.push(a), r.parentRequest !== null ? t(r.parentRequest, i) : i;
  }
  var e = t(n);
  return e.reverse().join(" --> ");
}
function ge(n) {
  n.childRequests.forEach(function(t) {
    if (pe(t, t.serviceIdentifier)) {
      var e = Vn(t);
      throw new Error(Sn + " " + e);
    } else
      ge(t);
  });
}
function Gn(n, t) {
  if (t.isTagged() || t.isNamed()) {
    var e = "", r = t.getNamedTag(), i = t.getCustomTags();
    return r !== null && (e += r.toString() + `
`), i !== null && i.forEach(function(a) {
      e += a.toString() + `
`;
    }), " " + n + `
 ` + n + " - " + e;
  } else
    return " " + n;
}
function vt(n) {
  if (n.name)
    return n.name;
  var t = n.toString(), e = t.match(/^function\s*([^\s(]+)/);
  return e ? e[1] : "Anonymous function: " + t;
}
function Yn(n) {
  return n.toString().slice(7, -1);
}
var ye = function() {
  function n(t) {
    this.id = it(), this.container = t;
  }
  return n.prototype.addPlan = function(t) {
    this.plan = t;
  }, n.prototype.setCurrentRequest = function(t) {
    this.currentRequest = t;
  }, n;
}(), z = function() {
  function n(t, e) {
    this.key = t, this.value = e;
  }
  return n.prototype.toString = function() {
    return this.key === L ? "named: " + String(this.value).toString() + " " : "tagged: { key:" + this.key.toString() + ", value: " + String(this.value) + " }";
  }, n;
}(), Hn = /* @__PURE__ */ function() {
  function n(t, e) {
    this.parentContext = t, this.rootRequest = e;
  }
  return n;
}(), Kn = function() {
  function n(t) {
    this._cb = t;
  }
  return n.prototype.unwrap = function() {
    return this._cb();
  }, n;
}(), zn = function() {
  function n(t) {
    this.str = t;
  }
  return n.prototype.startsWith = function(t) {
    return this.str.indexOf(t) === 0;
  }, n.prototype.endsWith = function(t) {
    var e = "", r = t.split("").reverse().join("");
    return e = this.str.split("").reverse().join(""), this.startsWith.call({ str: e }, r);
  }, n.prototype.contains = function(t) {
    return this.str.indexOf(t) !== -1;
  }, n.prototype.equals = function(t) {
    return this.str === t;
  }, n.prototype.value = function() {
    return this.str;
  }, n;
}(), pt = function() {
  function n(t, e, r, i) {
    this.id = it(), this.type = t, this.serviceIdentifier = r;
    var a = typeof e == "symbol" ? Yn(e) : e;
    this.name = new zn(a || ""), this.identifier = e, this.metadata = new Array();
    var s = null;
    typeof i == "string" ? s = new z(L, i) : i instanceof z && (s = i), s !== null && this.metadata.push(s);
  }
  return n.prototype.hasTag = function(t) {
    for (var e = 0, r = this.metadata; e < r.length; e++) {
      var i = r[e];
      if (i.key === t)
        return !0;
    }
    return !1;
  }, n.prototype.isArray = function() {
    return this.hasTag(tt);
  }, n.prototype.matchesArray = function(t) {
    return this.matchesTag(tt)(t);
  }, n.prototype.isNamed = function() {
    return this.hasTag(L);
  }, n.prototype.isTagged = function() {
    return this.metadata.some(function(t) {
      return ee.every(function(e) {
        return t.key !== e;
      });
    });
  }, n.prototype.isOptional = function() {
    return this.matchesTag(he)(!0);
  }, n.prototype.getNamedTag = function() {
    return this.isNamed() ? this.metadata.filter(function(t) {
      return t.key === L;
    })[0] : null;
  }, n.prototype.getCustomTags = function() {
    return this.isTagged() ? this.metadata.filter(function(t) {
      return ee.every(function(e) {
        return t.key !== e;
      });
    }) : null;
  }, n.prototype.matchesNamedTag = function(t) {
    return this.matchesTag(L)(t);
  }, n.prototype.matchesTag = function(t) {
    var e = this;
    return function(r) {
      for (var i = 0, a = e.metadata; i < a.length; i++) {
        var s = a[i];
        if (s.key === t && s.value === r)
          return !0;
      }
      return !1;
    };
  }, n;
}(), ct = function(n, t, e) {
  if (e || arguments.length === 2) for (var r = 0, i = t.length, a; r < i; r++)
    (a || !(r in t)) && (a || (a = Array.prototype.slice.call(t, 0, r)), a[r] = t[r]);
  return n.concat(a || Array.prototype.slice.call(t));
};
function Jn(n, t) {
  var e = vt(t);
  return me(n, e, t, !1);
}
function me(n, t, e, r) {
  var i = n.getConstructorMetadata(e), a = i.compilerGeneratedMetadata;
  if (a === void 0) {
    var s = de + " " + t + ".";
    throw new Error(s);
  }
  var l = i.userGeneratedMetadata, d = Object.keys(l), o = e.length === 0 && d.length > 0, h = d.length > e.length, _ = o || h ? d.length : e.length, S = qn(r, t, a, l, _), N = _e(n, e, t), x = ct(ct([], S, !0), N, !0);
  return x;
}
function Zn(n, t, e, r, i) {
  var a = i[n.toString()] || [], s = be(a), l = s.unmanaged !== !0, d = r[n], o = s.inject || s.multiInject;
  if (d = o || d, d instanceof Kn && (d = d.unwrap()), l) {
    var h = d === Object, _ = d === Function, S = d === void 0, N = h || _ || S;
    if (!t && N) {
      var x = Dn + " argument " + n + " in class " + e + ".";
      throw new Error(x);
    }
    var F = new pt(rt.ConstructorArgument, s.targetName, d);
    return F.metadata = a, F;
  }
  return null;
}
function qn(n, t, e, r, i) {
  for (var a = [], s = 0; s < i; s++) {
    var l = s, d = Zn(l, n, t, e, r);
    d !== null && a.push(d);
  }
  return a;
}
function Qn(n, t, e, r) {
  var i = n || t;
  if (i === void 0) {
    var a = de + " for property " + String(e) + " in class " + r + ".";
    throw new Error(a);
  }
  return i;
}
function _e(n, t, e) {
  for (var r = n.getPropertiesMetadata(t), i = [], a = Object.getOwnPropertySymbols(r), s = Object.keys(r), l = s.concat(a), d = 0, o = l; d < o.length; d++) {
    var h = o[d], _ = r[h], S = be(_), N = S.targetName || h, x = Qn(S.inject, S.multiInject, h, e), F = new pt(rt.ClassProperty, N, x);
    F.metadata = _, i.push(F);
  }
  var W = Object.getPrototypeOf(t.prototype).constructor;
  if (W !== Object) {
    var at = _e(n, W, e);
    i = ct(ct([], i, !0), at, !0);
  }
  return i;
}
function we(n, t) {
  var e = Object.getPrototypeOf(t.prototype).constructor;
  if (e !== Object) {
    var r = vt(e), i = me(n, r, e, !0), a = i.map(function(d) {
      return d.metadata.filter(function(o) {
        return o.key === Ot;
      });
    }), s = [].concat.apply([], a).length, l = i.length - s;
    return l > 0 ? l : we(n, e);
  } else
    return 0;
}
function be(n) {
  var t = {};
  return n.forEach(function(e) {
    t[e.key.toString()] = e.value;
  }), {
    inject: t[Nt],
    multiInject: t[tt],
    targetName: t[le],
    unmanaged: t[Ot]
  };
}
var Pt = function() {
  function n(t, e, r, i, a) {
    this.id = it(), this.serviceIdentifier = t, this.parentContext = e, this.parentRequest = r, this.target = a, this.childRequests = [], this.bindings = Array.isArray(i) ? i : [i], this.requestScope = r === null ? /* @__PURE__ */ new Map() : null;
  }
  return n.prototype.addChildRequest = function(t, e, r) {
    var i = new n(t, this.parentContext, this, e, r);
    return this.childRequests.push(i), i;
  }, n;
}();
function ft(n) {
  return n._bindingDictionary;
}
function Xn(n, t, e, r, i, a) {
  var s = n ? tt : Nt, l = new z(s, e), d = new pt(t, r, e, l);
  if (i !== void 0) {
    var o = new z(i, a);
    d.metadata.push(o);
  }
  return d;
}
function ie(n, t, e, r, i) {
  var a = nt(e.container, i.serviceIdentifier), s = [];
  return a.length === ut.NoBindingsAvailable && e.container.options.autoBindInjectable && typeof i.serviceIdentifier == "function" && n.getConstructorMetadata(i.serviceIdentifier).compilerGeneratedMetadata && (e.container.bind(i.serviceIdentifier).toSelf(), a = nt(e.container, i.serviceIdentifier)), t ? s = a : s = a.filter(function(l) {
    var d = new Pt(l.serviceIdentifier, e, r, l, i);
    return l.constraint(d);
  }), tr(i.serviceIdentifier, s, i, e.container), s;
}
function tr(n, t, e, r) {
  switch (t.length) {
    case ut.NoBindingsAvailable:
      if (e.isOptional())
        return t;
      var i = et(n), a = An;
      throw a += Gn(i, e), a += re(r, i, nt), new Error(a);
    case ut.OnlyOneBindingAvailable:
      return t;
    case ut.MultipleBindingsAvailable:
    default:
      if (e.isArray())
        return t;
      var i = et(n), a = wn + " " + i;
      throw a += re(r, i, nt), new Error(a);
  }
}
function Ae(n, t, e, r, i, a) {
  var s, l;
  if (i === null) {
    s = ie(n, t, r, null, a), l = new Pt(e, r, null, s, a);
    var d = new Hn(r, l);
    r.addPlan(d);
  } else
    s = ie(n, t, r, i, a), l = i.addChildRequest(a.serviceIdentifier, s, a);
  s.forEach(function(o) {
    var h = null;
    if (a.isArray())
      h = l.addChildRequest(o.serviceIdentifier, o, a);
    else {
      if (o.cache)
        return;
      h = l;
    }
    if (o.type === I.Instance && o.implementationType !== null) {
      var _ = Jn(n, o.implementationType);
      if (!r.container.options.skipBaseClassChecks) {
        var S = we(n, o.implementationType);
        if (_.length < S) {
          var N = Nn(vt(o.implementationType));
          throw new Error(N);
        }
      }
      _.forEach(function(x) {
        Ae(n, !1, x.serviceIdentifier, r, h, x);
      });
    }
  });
}
function nt(n, t) {
  var e = [], r = ft(n);
  return r.hasKey(t) ? e = r.get(t) : n.parent !== null && (e = nt(n.parent, t)), e;
}
function er(n, t, e, r, i, a, s, l) {
  l === void 0 && (l = !1);
  var d = new ye(t), o = Xn(e, r, i, "", a, s);
  try {
    return Ae(n, l, i, d, null, o), d;
  } catch (h) {
    throw ve(h) && ge(d.plan.rootRequest), h;
  }
}
function nr(n, t, e, r) {
  var i = new pt(rt.Variable, "", t, new z(e, r)), a = new ye(n), s = new Pt(t, a, null, [], i);
  return s;
}
function k(n) {
  var t = typeof n == "object" && n !== null || typeof n == "function";
  return t && typeof n.then == "function";
}
function De(n) {
  return k(n) ? !0 : Array.isArray(n) && n.some(k);
}
var rr = function(n, t, e, r) {
  function i(a) {
    return a instanceof e ? a : new e(function(s) {
      s(a);
    });
  }
  return new (e || (e = Promise))(function(a, s) {
    function l(h) {
      try {
        o(r.next(h));
      } catch (_) {
        s(_);
      }
    }
    function d(h) {
      try {
        o(r.throw(h));
      } catch (_) {
        s(_);
      }
    }
    function o(h) {
      h.done ? a(h.value) : i(h.value).then(l, d);
    }
    o((r = r.apply(n, t || [])).next());
  });
}, ir = function(n, t) {
  var e = { label: 0, sent: function() {
    if (a[0] & 1) throw a[1];
    return a[1];
  }, trys: [], ops: [] }, r, i, a, s;
  return s = { next: l(0), throw: l(1), return: l(2) }, typeof Symbol == "function" && (s[Symbol.iterator] = function() {
    return this;
  }), s;
  function l(o) {
    return function(h) {
      return d([o, h]);
    };
  }
  function d(o) {
    if (r) throw new TypeError("Generator is already executing.");
    for (; e; ) try {
      if (r = 1, i && (a = o[0] & 2 ? i.return : o[0] ? i.throw || ((a = i.return) && a.call(i), 0) : i.next) && !(a = a.call(i, o[1])).done) return a;
      switch (i = 0, a && (o = [o[0] & 2, a.value]), o[0]) {
        case 0:
        case 1:
          a = o;
          break;
        case 4:
          return e.label++, { value: o[1], done: !1 };
        case 5:
          e.label++, i = o[1], o = [0];
          continue;
        case 7:
          o = e.ops.pop(), e.trys.pop();
          continue;
        default:
          if (a = e.trys, !(a = a.length > 0 && a[a.length - 1]) && (o[0] === 6 || o[0] === 2)) {
            e = 0;
            continue;
          }
          if (o[0] === 3 && (!a || o[1] > a[0] && o[1] < a[3])) {
            e.label = o[1];
            break;
          }
          if (o[0] === 6 && e.label < a[1]) {
            e.label = a[1], a = o;
            break;
          }
          if (a && e.label < a[2]) {
            e.label = a[2], e.ops.push(o);
            break;
          }
          a[2] && e.ops.pop(), e.trys.pop();
          continue;
      }
      o = t.call(n, e);
    } catch (h) {
      o = [6, h], i = 0;
    } finally {
      r = a = 0;
    }
    if (o[0] & 5) throw o[1];
    return { value: o[0] ? o[1] : void 0, done: !0 };
  }
}, ar = function(n, t) {
  return t.scope === C.Singleton && t.activated ? t.cache : t.scope === C.Request && n.has(t.id) ? n.get(t.id) : null;
}, or = function(n, t, e) {
  t.scope === C.Singleton && ur(t, e), t.scope === C.Request && sr(n, t, e);
}, sr = function(n, t, e) {
  n.has(t.id) || n.set(t.id, e);
}, ur = function(n, t) {
  n.cache = t, n.activated = !0, k(t) && cr(n, t);
}, cr = function(n, t) {
  return rr(void 0, void 0, void 0, function() {
    var e, r;
    return ir(this, function(i) {
      switch (i.label) {
        case 0:
          return i.trys.push([0, 2, , 3]), [4, t];
        case 1:
          return e = i.sent(), n.cache = e, [3, 3];
        case 2:
          throw r = i.sent(), n.cache = null, n.activated = !1, r;
        case 3:
          return [2];
      }
    });
  });
}, X;
(function(n) {
  n.DynamicValue = "toDynamicValue", n.Factory = "toFactory", n.Provider = "toProvider";
})(X || (X = {}));
var fr = function(n) {
  var t = null;
  switch (n.type) {
    case I.ConstantValue:
    case I.Function:
      t = n.cache;
      break;
    case I.Constructor:
    case I.Instance:
      t = n.implementationType;
      break;
    case I.DynamicValue:
      t = n.dynamicValue;
      break;
    case I.Provider:
      t = n.provider;
      break;
    case I.Factory:
      t = n.factory;
      break;
  }
  if (t === null) {
    var e = et(n.serviceIdentifier);
    throw new Error(Tn + " " + e);
  }
}, lr = function(n) {
  switch (n.type) {
    case I.Factory:
      return { factory: n.factory, factoryType: X.Factory };
    case I.Provider:
      return { factory: n.provider, factoryType: X.Provider };
    case I.DynamicValue:
      return { factory: n.dynamicValue, factoryType: X.DynamicValue };
    default:
      throw new Error("Unexpected factory type " + n.type);
  }
}, J = function() {
  return J = Object.assign || function(n) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (n[i] = t[i]);
    }
    return n;
  }, J.apply(this, arguments);
}, Se = function(n, t, e, r) {
  function i(a) {
    return a instanceof e ? a : new e(function(s) {
      s(a);
    });
  }
  return new (e || (e = Promise))(function(a, s) {
    function l(h) {
      try {
        o(r.next(h));
      } catch (_) {
        s(_);
      }
    }
    function d(h) {
      try {
        o(r.throw(h));
      } catch (_) {
        s(_);
      }
    }
    function o(h) {
      h.done ? a(h.value) : i(h.value).then(l, d);
    }
    o((r = r.apply(n, t || [])).next());
  });
}, Te = function(n, t) {
  var e = { label: 0, sent: function() {
    if (a[0] & 1) throw a[1];
    return a[1];
  }, trys: [], ops: [] }, r, i, a, s;
  return s = { next: l(0), throw: l(1), return: l(2) }, typeof Symbol == "function" && (s[Symbol.iterator] = function() {
    return this;
  }), s;
  function l(o) {
    return function(h) {
      return d([o, h]);
    };
  }
  function d(o) {
    if (r) throw new TypeError("Generator is already executing.");
    for (; e; ) try {
      if (r = 1, i && (a = o[0] & 2 ? i.return : o[0] ? i.throw || ((a = i.return) && a.call(i), 0) : i.next) && !(a = a.call(i, o[1])).done) return a;
      switch (i = 0, a && (o = [o[0] & 2, a.value]), o[0]) {
        case 0:
        case 1:
          a = o;
          break;
        case 4:
          return e.label++, { value: o[1], done: !1 };
        case 5:
          e.label++, i = o[1], o = [0];
          continue;
        case 7:
          o = e.ops.pop(), e.trys.pop();
          continue;
        default:
          if (a = e.trys, !(a = a.length > 0 && a[a.length - 1]) && (o[0] === 6 || o[0] === 2)) {
            e = 0;
            continue;
          }
          if (o[0] === 3 && (!a || o[1] > a[0] && o[1] < a[3])) {
            e.label = o[1];
            break;
          }
          if (o[0] === 6 && e.label < a[1]) {
            e.label = a[1], a = o;
            break;
          }
          if (a && e.label < a[2]) {
            e.label = a[2], e.ops.push(o);
            break;
          }
          a[2] && e.ops.pop(), e.trys.pop();
          continue;
      }
      o = t.call(n, e);
    } catch (h) {
      o = [6, h], i = 0;
    } finally {
      r = a = 0;
    }
    if (o[0] & 5) throw o[1];
    return { value: o[0] ? o[1] : void 0, done: !0 };
  }
}, hr = function(n, t, e) {
  if (e || arguments.length === 2) for (var r = 0, i = t.length, a; r < i; r++)
    (a || !(r in t)) && (a || (a = Array.prototype.slice.call(t, 0, r)), a[r] = t[r]);
  return n.concat(a || Array.prototype.slice.call(t));
};
function dr(n, t) {
  return n.reduce(function(e, r) {
    var i = t(r), a = r.target.type;
    return a === rt.ConstructorArgument ? e.constructorInjections.push(i) : (e.propertyRequests.push(r), e.propertyInjections.push(i)), e.isAsync || (e.isAsync = De(i)), e;
  }, { constructorInjections: [], propertyInjections: [], propertyRequests: [], isAsync: !1 });
}
function vr(n, t, e) {
  var r;
  if (t.length > 0) {
    var i = dr(t, e), a = J(J({}, i), { constr: n });
    i.isAsync ? r = pr(a) : r = Ie(a);
  } else
    r = new n();
  return r;
}
function Ie(n) {
  var t, e = new ((t = n.constr).bind.apply(t, hr([void 0], n.constructorInjections, !1)))();
  return n.propertyRequests.forEach(function(r, i) {
    var a = r.target.identifier, s = n.propertyInjections[i];
    (!r.target.isOptional() || s !== void 0) && (e[a] = s);
  }), e;
}
function pr(n) {
  return Se(this, void 0, void 0, function() {
    var t, e;
    return Te(this, function(r) {
      switch (r.label) {
        case 0:
          return [4, ae(n.constructorInjections)];
        case 1:
          return t = r.sent(), [4, ae(n.propertyInjections)];
        case 2:
          return e = r.sent(), [2, Ie(J(J({}, n), { constructorInjections: t, propertyInjections: e }))];
      }
    });
  });
}
function ae(n) {
  return Se(this, void 0, void 0, function() {
    var t, e, r, i;
    return Te(this, function(a) {
      for (t = [], e = 0, r = n; e < r.length; e++)
        i = r[e], Array.isArray(i) ? t.push(Promise.all(i)) : t.push(i);
      return [2, Promise.all(t)];
    });
  });
}
function oe(n, t) {
  var e = gr(n, t);
  return k(e) ? e.then(function() {
    return t;
  }) : t;
}
function gr(n, t) {
  var e, r;
  if (Reflect.hasMetadata(te, n)) {
    var i = Reflect.getMetadata(te, n);
    try {
      return (r = (e = t)[i.value]) === null || r === void 0 ? void 0 : r.call(e);
    } catch (a) {
      if (a instanceof Error)
        throw new Error(Bn(n.name, a.message));
    }
  }
}
function yr(n, t) {
  n.scope !== C.Singleton && mr(n, t);
}
function mr(n, t) {
  var e = "Class cannot be instantiated in " + (n.scope === C.Request ? "request" : "transient") + " scope.";
  if (typeof n.onDeactivation == "function")
    throw new Error(St(t.name, e));
  if (Reflect.hasMetadata(Dt, t))
    throw new Error(jn(t.name, e));
}
function _r(n, t, e, r) {
  yr(n, t);
  var i = vr(t, e, r);
  return k(i) ? i.then(function(a) {
    return oe(t, a);
  }) : oe(t, i);
}
var wr = function(n, t, e, r) {
  function i(a) {
    return a instanceof e ? a : new e(function(s) {
      s(a);
    });
  }
  return new (e || (e = Promise))(function(a, s) {
    function l(h) {
      try {
        o(r.next(h));
      } catch (_) {
        s(_);
      }
    }
    function d(h) {
      try {
        o(r.throw(h));
      } catch (_) {
        s(_);
      }
    }
    function o(h) {
      h.done ? a(h.value) : i(h.value).then(l, d);
    }
    o((r = r.apply(n, t || [])).next());
  });
}, br = function(n, t) {
  var e = { label: 0, sent: function() {
    if (a[0] & 1) throw a[1];
    return a[1];
  }, trys: [], ops: [] }, r, i, a, s;
  return s = { next: l(0), throw: l(1), return: l(2) }, typeof Symbol == "function" && (s[Symbol.iterator] = function() {
    return this;
  }), s;
  function l(o) {
    return function(h) {
      return d([o, h]);
    };
  }
  function d(o) {
    if (r) throw new TypeError("Generator is already executing.");
    for (; e; ) try {
      if (r = 1, i && (a = o[0] & 2 ? i.return : o[0] ? i.throw || ((a = i.return) && a.call(i), 0) : i.next) && !(a = a.call(i, o[1])).done) return a;
      switch (i = 0, a && (o = [o[0] & 2, a.value]), o[0]) {
        case 0:
        case 1:
          a = o;
          break;
        case 4:
          return e.label++, { value: o[1], done: !1 };
        case 5:
          e.label++, i = o[1], o = [0];
          continue;
        case 7:
          o = e.ops.pop(), e.trys.pop();
          continue;
        default:
          if (a = e.trys, !(a = a.length > 0 && a[a.length - 1]) && (o[0] === 6 || o[0] === 2)) {
            e = 0;
            continue;
          }
          if (o[0] === 3 && (!a || o[1] > a[0] && o[1] < a[3])) {
            e.label = o[1];
            break;
          }
          if (o[0] === 6 && e.label < a[1]) {
            e.label = a[1], a = o;
            break;
          }
          if (a && e.label < a[2]) {
            e.label = a[2], e.ops.push(o);
            break;
          }
          a[2] && e.ops.pop(), e.trys.pop();
          continue;
      }
      o = t.call(n, e);
    } catch (h) {
      o = [6, h], i = 0;
    } finally {
      r = a = 0;
    }
    if (o[0] & 5) throw o[1];
    return { value: o[0] ? o[1] : void 0, done: !0 };
  }
}, Rt = function(n) {
  return function(t) {
    t.parentContext.setCurrentRequest(t);
    var e = t.bindings, r = t.childRequests, i = t.target && t.target.isArray(), a = !t.parentRequest || !t.parentRequest.target || !t.target || !t.parentRequest.target.matchesArray(t.target.serviceIdentifier);
    if (i && a)
      return r.map(function(l) {
        var d = Rt(n);
        return d(l);
      });
    if (t.target.isOptional() && e.length === 0)
      return;
    var s = e[0];
    return Tr(n, t, s);
  };
}, Ar = function(n, t) {
  var e = lr(n);
  return Wn(function() {
    return e.factory.bind(n)(t);
  }, function() {
    return new Error(Ln(e.factoryType, t.currentRequest.serviceIdentifier.toString()));
  });
}, Dr = function(n, t, e) {
  var r, i = t.childRequests;
  switch (fr(e), e.type) {
    case I.ConstantValue:
    case I.Function:
      r = e.cache;
      break;
    case I.Constructor:
      r = e.implementationType;
      break;
    case I.Instance:
      r = _r(e, e.implementationType, i, Rt(n));
      break;
    default:
      r = Ar(e, t.parentContext);
  }
  return r;
}, Sr = function(n, t, e) {
  var r = ar(n, t);
  return r !== null || (r = e(), or(n, t, r)), r;
}, Tr = function(n, t, e) {
  return Sr(n, e, function() {
    var r = Dr(n, t, e);
    return k(r) ? r = r.then(function(i) {
      return se(t, e, i);
    }) : r = se(t, e, r), r;
  });
};
function se(n, t, e) {
  var r = Ir(n.parentContext, t, e), i = Er(n.parentContext.container), a, s = i.next();
  do {
    a = s.value;
    var l = n.parentContext, d = n.serviceIdentifier, o = Cr(a, d);
    k(r) ? r = Me(o, l, r) : r = Mr(o, l, r), s = i.next();
  } while (s.done !== !0 && !ft(a).hasKey(n.serviceIdentifier));
  return r;
}
var Ir = function(n, t, e) {
  var r;
  return typeof t.onActivation == "function" ? r = t.onActivation(n, e) : r = e, r;
}, Mr = function(n, t, e) {
  for (var r = n.next(); !r.done; ) {
    if (e = r.value(t, e), k(e))
      return Me(n, t, e);
    r = n.next();
  }
  return e;
}, Me = function(n, t, e) {
  return wr(void 0, void 0, void 0, function() {
    var r, i;
    return br(this, function(a) {
      switch (a.label) {
        case 0:
          return [4, e];
        case 1:
          r = a.sent(), i = n.next(), a.label = 2;
        case 2:
          return i.done ? [3, 4] : [4, i.value(t, r)];
        case 3:
          return r = a.sent(), i = n.next(), [3, 2];
        case 4:
          return [2, r];
      }
    });
  });
}, Cr = function(n, t) {
  var e = n._activations;
  return e.hasKey(t) ? e.get(t).values() : [].values();
}, Er = function(n) {
  for (var t = [n], e = n.parent; e !== null; )
    t.push(e), e = e.parent;
  var r = function() {
    var a = t.pop();
    return a !== void 0 ? { done: !1, value: a } : { done: !0, value: void 0 };
  }, i = {
    next: r
  };
  return i;
};
function Or(n) {
  var t = Rt(n.plan.rootRequest.requestScope);
  return t(n.plan.rootRequest);
}
var V = function(n, t) {
  var e = n.parentRequest;
  return e !== null ? t(e) ? !0 : V(e, t) : !1;
}, Q = function(n) {
  return function(t) {
    var e = function(r) {
      return r !== null && r.target !== null && r.target.matchesTag(n)(t);
    };
    return e.metaData = new z(n, t), e;
  };
}, st = Q(L), wt = function(n) {
  return function(t) {
    var e = null;
    if (t !== null)
      if (e = t.bindings[0], typeof n == "string") {
        var r = e.serviceIdentifier;
        return r === n;
      } else {
        var i = t.bindings[0].implementationType;
        return n === i;
      }
    return !1;
  };
}, lt = function() {
  function n(t) {
    this._binding = t;
  }
  return n.prototype.when = function(t) {
    return this._binding.constraint = t, new R(this._binding);
  }, n.prototype.whenTargetNamed = function(t) {
    return this._binding.constraint = st(t), new R(this._binding);
  }, n.prototype.whenTargetIsDefault = function() {
    return this._binding.constraint = function(t) {
      if (t === null)
        return !1;
      var e = t.target !== null && !t.target.isNamed() && !t.target.isTagged();
      return e;
    }, new R(this._binding);
  }, n.prototype.whenTargetTagged = function(t, e) {
    return this._binding.constraint = Q(t)(e), new R(this._binding);
  }, n.prototype.whenInjectedInto = function(t) {
    return this._binding.constraint = function(e) {
      return e !== null && wt(t)(e.parentRequest);
    }, new R(this._binding);
  }, n.prototype.whenParentNamed = function(t) {
    return this._binding.constraint = function(e) {
      return e !== null && st(t)(e.parentRequest);
    }, new R(this._binding);
  }, n.prototype.whenParentTagged = function(t, e) {
    return this._binding.constraint = function(r) {
      return r !== null && Q(t)(e)(r.parentRequest);
    }, new R(this._binding);
  }, n.prototype.whenAnyAncestorIs = function(t) {
    return this._binding.constraint = function(e) {
      return e !== null && V(e, wt(t));
    }, new R(this._binding);
  }, n.prototype.whenNoAncestorIs = function(t) {
    return this._binding.constraint = function(e) {
      return e !== null && !V(e, wt(t));
    }, new R(this._binding);
  }, n.prototype.whenAnyAncestorNamed = function(t) {
    return this._binding.constraint = function(e) {
      return e !== null && V(e, st(t));
    }, new R(this._binding);
  }, n.prototype.whenNoAncestorNamed = function(t) {
    return this._binding.constraint = function(e) {
      return e !== null && !V(e, st(t));
    }, new R(this._binding);
  }, n.prototype.whenAnyAncestorTagged = function(t, e) {
    return this._binding.constraint = function(r) {
      return r !== null && V(r, Q(t)(e));
    }, new R(this._binding);
  }, n.prototype.whenNoAncestorTagged = function(t, e) {
    return this._binding.constraint = function(r) {
      return r !== null && !V(r, Q(t)(e));
    }, new R(this._binding);
  }, n.prototype.whenAnyAncestorMatches = function(t) {
    return this._binding.constraint = function(e) {
      return e !== null && V(e, t);
    }, new R(this._binding);
  }, n.prototype.whenNoAncestorMatches = function(t) {
    return this._binding.constraint = function(e) {
      return e !== null && !V(e, t);
    }, new R(this._binding);
  }, n;
}(), R = function() {
  function n(t) {
    this._binding = t;
  }
  return n.prototype.onActivation = function(t) {
    return this._binding.onActivation = t, new lt(this._binding);
  }, n.prototype.onDeactivation = function(t) {
    return this._binding.onDeactivation = t, new lt(this._binding);
  }, n;
}(), G = function() {
  function n(t) {
    this._binding = t, this._bindingWhenSyntax = new lt(this._binding), this._bindingOnSyntax = new R(this._binding);
  }
  return n.prototype.when = function(t) {
    return this._bindingWhenSyntax.when(t);
  }, n.prototype.whenTargetNamed = function(t) {
    return this._bindingWhenSyntax.whenTargetNamed(t);
  }, n.prototype.whenTargetIsDefault = function() {
    return this._bindingWhenSyntax.whenTargetIsDefault();
  }, n.prototype.whenTargetTagged = function(t, e) {
    return this._bindingWhenSyntax.whenTargetTagged(t, e);
  }, n.prototype.whenInjectedInto = function(t) {
    return this._bindingWhenSyntax.whenInjectedInto(t);
  }, n.prototype.whenParentNamed = function(t) {
    return this._bindingWhenSyntax.whenParentNamed(t);
  }, n.prototype.whenParentTagged = function(t, e) {
    return this._bindingWhenSyntax.whenParentTagged(t, e);
  }, n.prototype.whenAnyAncestorIs = function(t) {
    return this._bindingWhenSyntax.whenAnyAncestorIs(t);
  }, n.prototype.whenNoAncestorIs = function(t) {
    return this._bindingWhenSyntax.whenNoAncestorIs(t);
  }, n.prototype.whenAnyAncestorNamed = function(t) {
    return this._bindingWhenSyntax.whenAnyAncestorNamed(t);
  }, n.prototype.whenAnyAncestorTagged = function(t, e) {
    return this._bindingWhenSyntax.whenAnyAncestorTagged(t, e);
  }, n.prototype.whenNoAncestorNamed = function(t) {
    return this._bindingWhenSyntax.whenNoAncestorNamed(t);
  }, n.prototype.whenNoAncestorTagged = function(t, e) {
    return this._bindingWhenSyntax.whenNoAncestorTagged(t, e);
  }, n.prototype.whenAnyAncestorMatches = function(t) {
    return this._bindingWhenSyntax.whenAnyAncestorMatches(t);
  }, n.prototype.whenNoAncestorMatches = function(t) {
    return this._bindingWhenSyntax.whenNoAncestorMatches(t);
  }, n.prototype.onActivation = function(t) {
    return this._bindingOnSyntax.onActivation(t);
  }, n.prototype.onDeactivation = function(t) {
    return this._bindingOnSyntax.onDeactivation(t);
  }, n;
}(), Nr = function() {
  function n(t) {
    this._binding = t;
  }
  return n.prototype.inRequestScope = function() {
    return this._binding.scope = C.Request, new G(this._binding);
  }, n.prototype.inSingletonScope = function() {
    return this._binding.scope = C.Singleton, new G(this._binding);
  }, n.prototype.inTransientScope = function() {
    return this._binding.scope = C.Transient, new G(this._binding);
  }, n;
}(), ue = function() {
  function n(t) {
    this._binding = t, this._bindingWhenSyntax = new lt(this._binding), this._bindingOnSyntax = new R(this._binding), this._bindingInSyntax = new Nr(t);
  }
  return n.prototype.inRequestScope = function() {
    return this._bindingInSyntax.inRequestScope();
  }, n.prototype.inSingletonScope = function() {
    return this._bindingInSyntax.inSingletonScope();
  }, n.prototype.inTransientScope = function() {
    return this._bindingInSyntax.inTransientScope();
  }, n.prototype.when = function(t) {
    return this._bindingWhenSyntax.when(t);
  }, n.prototype.whenTargetNamed = function(t) {
    return this._bindingWhenSyntax.whenTargetNamed(t);
  }, n.prototype.whenTargetIsDefault = function() {
    return this._bindingWhenSyntax.whenTargetIsDefault();
  }, n.prototype.whenTargetTagged = function(t, e) {
    return this._bindingWhenSyntax.whenTargetTagged(t, e);
  }, n.prototype.whenInjectedInto = function(t) {
    return this._bindingWhenSyntax.whenInjectedInto(t);
  }, n.prototype.whenParentNamed = function(t) {
    return this._bindingWhenSyntax.whenParentNamed(t);
  }, n.prototype.whenParentTagged = function(t, e) {
    return this._bindingWhenSyntax.whenParentTagged(t, e);
  }, n.prototype.whenAnyAncestorIs = function(t) {
    return this._bindingWhenSyntax.whenAnyAncestorIs(t);
  }, n.prototype.whenNoAncestorIs = function(t) {
    return this._bindingWhenSyntax.whenNoAncestorIs(t);
  }, n.prototype.whenAnyAncestorNamed = function(t) {
    return this._bindingWhenSyntax.whenAnyAncestorNamed(t);
  }, n.prototype.whenAnyAncestorTagged = function(t, e) {
    return this._bindingWhenSyntax.whenAnyAncestorTagged(t, e);
  }, n.prototype.whenNoAncestorNamed = function(t) {
    return this._bindingWhenSyntax.whenNoAncestorNamed(t);
  }, n.prototype.whenNoAncestorTagged = function(t, e) {
    return this._bindingWhenSyntax.whenNoAncestorTagged(t, e);
  }, n.prototype.whenAnyAncestorMatches = function(t) {
    return this._bindingWhenSyntax.whenAnyAncestorMatches(t);
  }, n.prototype.whenNoAncestorMatches = function(t) {
    return this._bindingWhenSyntax.whenNoAncestorMatches(t);
  }, n.prototype.onActivation = function(t) {
    return this._bindingOnSyntax.onActivation(t);
  }, n.prototype.onDeactivation = function(t) {
    return this._bindingOnSyntax.onDeactivation(t);
  }, n;
}(), Pr = function() {
  function n(t) {
    this._binding = t;
  }
  return n.prototype.to = function(t) {
    return this._binding.type = I.Instance, this._binding.implementationType = t, new ue(this._binding);
  }, n.prototype.toSelf = function() {
    if (typeof this._binding.serviceIdentifier != "function")
      throw new Error("" + On);
    var t = this._binding.serviceIdentifier;
    return this.to(t);
  }, n.prototype.toConstantValue = function(t) {
    return this._binding.type = I.ConstantValue, this._binding.cache = t, this._binding.dynamicValue = null, this._binding.implementationType = null, this._binding.scope = C.Singleton, new G(this._binding);
  }, n.prototype.toDynamicValue = function(t) {
    return this._binding.type = I.DynamicValue, this._binding.cache = null, this._binding.dynamicValue = t, this._binding.implementationType = null, new ue(this._binding);
  }, n.prototype.toConstructor = function(t) {
    return this._binding.type = I.Constructor, this._binding.implementationType = t, this._binding.scope = C.Singleton, new G(this._binding);
  }, n.prototype.toFactory = function(t) {
    return this._binding.type = I.Factory, this._binding.factory = t, this._binding.scope = C.Singleton, new G(this._binding);
  }, n.prototype.toFunction = function(t) {
    if (typeof t != "function")
      throw new Error(Cn);
    var e = this.toConstantValue(t);
    return this._binding.type = I.Function, this._binding.scope = C.Singleton, e;
  }, n.prototype.toAutoFactory = function(t) {
    return this._binding.type = I.Factory, this._binding.factory = function(e) {
      var r = function() {
        return e.container.get(t);
      };
      return r;
    }, this._binding.scope = C.Singleton, new G(this._binding);
  }, n.prototype.toAutoNamedFactory = function(t) {
    return this._binding.type = I.Factory, this._binding.factory = function(e) {
      return function(r) {
        return e.container.getNamed(t, r);
      };
    }, new G(this._binding);
  }, n.prototype.toProvider = function(t) {
    return this._binding.type = I.Provider, this._binding.provider = t, this._binding.scope = C.Singleton, new G(this._binding);
  }, n.prototype.toService = function(t) {
    this.toDynamicValue(function(e) {
      return e.container.get(t);
    });
  }, n;
}(), Rr = function() {
  function n() {
  }
  return n.of = function(t, e, r, i, a) {
    var s = new n();
    return s.bindings = t, s.middleware = e, s.deactivations = i, s.activations = r, s.moduleActivationStore = a, s;
  }, n;
}();
function xr(n) {
  return typeof n == "object" && n !== null && "clone" in n && typeof n.clone == "function";
}
var H = function() {
  function n() {
    this._map = /* @__PURE__ */ new Map();
  }
  return n.prototype.getMap = function() {
    return this._map;
  }, n.prototype.add = function(t, e) {
    if (t == null)
      throw new Error(q);
    if (e == null)
      throw new Error(q);
    var r = this._map.get(t);
    r !== void 0 ? r.push(e) : this._map.set(t, [e]);
  }, n.prototype.get = function(t) {
    if (t == null)
      throw new Error(q);
    var e = this._map.get(t);
    if (e !== void 0)
      return e;
    throw new Error(ne);
  }, n.prototype.remove = function(t) {
    if (t == null)
      throw new Error(q);
    if (!this._map.delete(t))
      throw new Error(ne);
  }, n.prototype.removeIntersection = function(t) {
    var e = this;
    this.traverse(function(r, i) {
      var a = t.hasKey(r) ? t.get(r) : void 0;
      if (a !== void 0) {
        var s = i.filter(function(l) {
          return !a.some(function(d) {
            return l === d;
          });
        });
        e._setValue(r, s);
      }
    });
  }, n.prototype.removeByCondition = function(t) {
    var e = this, r = [];
    return this._map.forEach(function(i, a) {
      for (var s = [], l = 0, d = i; l < d.length; l++) {
        var o = d[l], h = t(o);
        h ? r.push(o) : s.push(o);
      }
      e._setValue(a, s);
    }), r;
  }, n.prototype.hasKey = function(t) {
    if (t == null)
      throw new Error(q);
    return this._map.has(t);
  }, n.prototype.clone = function() {
    var t = new n();
    return this._map.forEach(function(e, r) {
      e.forEach(function(i) {
        return t.add(r, xr(i) ? i.clone() : i);
      });
    }), t;
  }, n.prototype.traverse = function(t) {
    this._map.forEach(function(e, r) {
      t(r, e);
    });
  }, n.prototype._setValue = function(t, e) {
    e.length > 0 ? this._map.set(t, e) : this._map.delete(t);
  }, n;
}(), Fr = function() {
  function n() {
    this._map = /* @__PURE__ */ new Map();
  }
  return n.prototype.remove = function(t) {
    if (this._map.has(t)) {
      var e = this._map.get(t);
      return this._map.delete(t), e;
    }
    return this._getEmptyHandlersStore();
  }, n.prototype.addDeactivation = function(t, e, r) {
    this._getModuleActivationHandlers(t).onDeactivations.add(e, r);
  }, n.prototype.addActivation = function(t, e, r) {
    this._getModuleActivationHandlers(t).onActivations.add(e, r);
  }, n.prototype.clone = function() {
    var t = new n();
    return this._map.forEach(function(e, r) {
      t._map.set(r, {
        onActivations: e.onActivations.clone(),
        onDeactivations: e.onDeactivations.clone()
      });
    }), t;
  }, n.prototype._getModuleActivationHandlers = function(t) {
    var e = this._map.get(t);
    return e === void 0 && (e = this._getEmptyHandlersStore(), this._map.set(t, e)), e;
  }, n.prototype._getEmptyHandlersStore = function() {
    var t = {
      onActivations: new H(),
      onDeactivations: new H()
    };
    return t;
  }, n;
}(), ht = function() {
  return ht = Object.assign || function(n) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (n[i] = t[i]);
    }
    return n;
  }, ht.apply(this, arguments);
}, B = function(n, t, e, r) {
  function i(a) {
    return a instanceof e ? a : new e(function(s) {
      s(a);
    });
  }
  return new (e || (e = Promise))(function(a, s) {
    function l(h) {
      try {
        o(r.next(h));
      } catch (_) {
        s(_);
      }
    }
    function d(h) {
      try {
        o(r.throw(h));
      } catch (_) {
        s(_);
      }
    }
    function o(h) {
      h.done ? a(h.value) : i(h.value).then(l, d);
    }
    o((r = r.apply(n, t || [])).next());
  });
}, j = function(n, t) {
  var e = { label: 0, sent: function() {
    if (a[0] & 1) throw a[1];
    return a[1];
  }, trys: [], ops: [] }, r, i, a, s;
  return s = { next: l(0), throw: l(1), return: l(2) }, typeof Symbol == "function" && (s[Symbol.iterator] = function() {
    return this;
  }), s;
  function l(o) {
    return function(h) {
      return d([o, h]);
    };
  }
  function d(o) {
    if (r) throw new TypeError("Generator is already executing.");
    for (; e; ) try {
      if (r = 1, i && (a = o[0] & 2 ? i.return : o[0] ? i.throw || ((a = i.return) && a.call(i), 0) : i.next) && !(a = a.call(i, o[1])).done) return a;
      switch (i = 0, a && (o = [o[0] & 2, a.value]), o[0]) {
        case 0:
        case 1:
          a = o;
          break;
        case 4:
          return e.label++, { value: o[1], done: !1 };
        case 5:
          e.label++, i = o[1], o = [0];
          continue;
        case 7:
          o = e.ops.pop(), e.trys.pop();
          continue;
        default:
          if (a = e.trys, !(a = a.length > 0 && a[a.length - 1]) && (o[0] === 6 || o[0] === 2)) {
            e = 0;
            continue;
          }
          if (o[0] === 3 && (!a || o[1] > a[0] && o[1] < a[3])) {
            e.label = o[1];
            break;
          }
          if (o[0] === 6 && e.label < a[1]) {
            e.label = a[1], a = o;
            break;
          }
          if (a && e.label < a[2]) {
            e.label = a[2], e.ops.push(o);
            break;
          }
          a[2] && e.ops.pop(), e.trys.pop();
          continue;
      }
      o = t.call(n, e);
    } catch (h) {
      o = [6, h], i = 0;
    } finally {
      r = a = 0;
    }
    if (o[0] & 5) throw o[1];
    return { value: o[0] ? o[1] : void 0, done: !0 };
  }
}, kr = function(n, t, e) {
  if (e || arguments.length === 2) for (var r = 0, i = t.length, a; r < i; r++)
    (a || !(r in t)) && (a || (a = Array.prototype.slice.call(t, 0, r)), a[r] = t[r]);
  return n.concat(a || Array.prototype.slice.call(t));
}, Br = function() {
  function n(t) {
    var e = t || {};
    if (typeof e != "object")
      throw new Error("" + Pn);
    if (e.defaultScope === void 0)
      e.defaultScope = C.Transient;
    else if (e.defaultScope !== C.Singleton && e.defaultScope !== C.Transient && e.defaultScope !== C.Request)
      throw new Error("" + Rn);
    if (e.autoBindInjectable === void 0)
      e.autoBindInjectable = !1;
    else if (typeof e.autoBindInjectable != "boolean")
      throw new Error("" + xn);
    if (e.skipBaseClassChecks === void 0)
      e.skipBaseClassChecks = !1;
    else if (typeof e.skipBaseClassChecks != "boolean")
      throw new Error("" + Fn);
    this.options = {
      autoBindInjectable: e.autoBindInjectable,
      defaultScope: e.defaultScope,
      skipBaseClassChecks: e.skipBaseClassChecks
    }, this.id = it(), this._bindingDictionary = new H(), this._snapshots = [], this._middleware = null, this._activations = new H(), this._deactivations = new H(), this.parent = null, this._metadataReader = new $n(), this._moduleActivationStore = new Fr();
  }
  return n.merge = function(t, e) {
    for (var r = [], i = 2; i < arguments.length; i++)
      r[i - 2] = arguments[i];
    var a = new n(), s = kr([t, e], r, !0).map(function(o) {
      return ft(o);
    }), l = ft(a);
    function d(o, h) {
      o.traverse(function(_, S) {
        S.forEach(function(N) {
          h.add(N.serviceIdentifier, N.clone());
        });
      });
    }
    return s.forEach(function(o) {
      d(o, l);
    }), a;
  }, n.prototype.load = function() {
    for (var t = [], e = 0; e < arguments.length; e++)
      t[e] = arguments[e];
    for (var r = this._getContainerModuleHelpersFactory(), i = 0, a = t; i < a.length; i++) {
      var s = a[i], l = r(s.id);
      s.registry(l.bindFunction, l.unbindFunction, l.isboundFunction, l.rebindFunction, l.unbindAsyncFunction, l.onActivationFunction, l.onDeactivationFunction);
    }
  }, n.prototype.loadAsync = function() {
    for (var t = [], e = 0; e < arguments.length; e++)
      t[e] = arguments[e];
    return B(this, void 0, void 0, function() {
      var r, i, a, s, l;
      return j(this, function(d) {
        switch (d.label) {
          case 0:
            r = this._getContainerModuleHelpersFactory(), i = 0, a = t, d.label = 1;
          case 1:
            return i < a.length ? (s = a[i], l = r(s.id), [4, s.registry(l.bindFunction, l.unbindFunction, l.isboundFunction, l.rebindFunction, l.unbindAsyncFunction, l.onActivationFunction, l.onDeactivationFunction)]) : [3, 4];
          case 2:
            d.sent(), d.label = 3;
          case 3:
            return i++, [3, 1];
          case 4:
            return [2];
        }
      });
    });
  }, n.prototype.unload = function() {
    for (var t = this, e = [], r = 0; r < arguments.length; r++)
      e[r] = arguments[r];
    e.forEach(function(i) {
      var a = t._removeModuleBindings(i.id);
      t._deactivateSingletons(a), t._removeModuleHandlers(i.id);
    });
  }, n.prototype.unloadAsync = function() {
    for (var t = [], e = 0; e < arguments.length; e++)
      t[e] = arguments[e];
    return B(this, void 0, void 0, function() {
      var r, i, a, s;
      return j(this, function(l) {
        switch (l.label) {
          case 0:
            r = 0, i = t, l.label = 1;
          case 1:
            return r < i.length ? (a = i[r], s = this._removeModuleBindings(a.id), [4, this._deactivateSingletonsAsync(s)]) : [3, 4];
          case 2:
            l.sent(), this._removeModuleHandlers(a.id), l.label = 3;
          case 3:
            return r++, [3, 1];
          case 4:
            return [2];
        }
      });
    });
  }, n.prototype.bind = function(t) {
    var e = this.options.defaultScope || C.Transient, r = new mn(t, e);
    return this._bindingDictionary.add(t, r), new Pr(r);
  }, n.prototype.rebind = function(t) {
    return this.unbind(t), this.bind(t);
  }, n.prototype.rebindAsync = function(t) {
    return B(this, void 0, void 0, function() {
      return j(this, function(e) {
        switch (e.label) {
          case 0:
            return [4, this.unbindAsync(t)];
          case 1:
            return e.sent(), [2, this.bind(t)];
        }
      });
    });
  }, n.prototype.unbind = function(t) {
    if (this._bindingDictionary.hasKey(t)) {
      var e = this._bindingDictionary.get(t);
      this._deactivateSingletons(e);
    }
    this._removeServiceFromDictionary(t);
  }, n.prototype.unbindAsync = function(t) {
    return B(this, void 0, void 0, function() {
      var e;
      return j(this, function(r) {
        switch (r.label) {
          case 0:
            return this._bindingDictionary.hasKey(t) ? (e = this._bindingDictionary.get(t), [4, this._deactivateSingletonsAsync(e)]) : [3, 2];
          case 1:
            r.sent(), r.label = 2;
          case 2:
            return this._removeServiceFromDictionary(t), [2];
        }
      });
    });
  }, n.prototype.unbindAll = function() {
    var t = this;
    this._bindingDictionary.traverse(function(e, r) {
      t._deactivateSingletons(r);
    }), this._bindingDictionary = new H();
  }, n.prototype.unbindAllAsync = function() {
    return B(this, void 0, void 0, function() {
      var t, e = this;
      return j(this, function(r) {
        switch (r.label) {
          case 0:
            return t = [], this._bindingDictionary.traverse(function(i, a) {
              t.push(e._deactivateSingletonsAsync(a));
            }), [4, Promise.all(t)];
          case 1:
            return r.sent(), this._bindingDictionary = new H(), [2];
        }
      });
    });
  }, n.prototype.onActivation = function(t, e) {
    this._activations.add(t, e);
  }, n.prototype.onDeactivation = function(t, e) {
    this._deactivations.add(t, e);
  }, n.prototype.isBound = function(t) {
    var e = this._bindingDictionary.hasKey(t);
    return !e && this.parent && (e = this.parent.isBound(t)), e;
  }, n.prototype.isCurrentBound = function(t) {
    return this._bindingDictionary.hasKey(t);
  }, n.prototype.isBoundNamed = function(t, e) {
    return this.isBoundTagged(t, L, e);
  }, n.prototype.isBoundTagged = function(t, e, r) {
    var i = !1;
    if (this._bindingDictionary.hasKey(t)) {
      var a = this._bindingDictionary.get(t), s = nr(this, t, e, r);
      i = a.some(function(l) {
        return l.constraint(s);
      });
    }
    return !i && this.parent && (i = this.parent.isBoundTagged(t, e, r)), i;
  }, n.prototype.snapshot = function() {
    this._snapshots.push(Rr.of(this._bindingDictionary.clone(), this._middleware, this._activations.clone(), this._deactivations.clone(), this._moduleActivationStore.clone()));
  }, n.prototype.restore = function() {
    var t = this._snapshots.pop();
    if (t === void 0)
      throw new Error(In);
    this._bindingDictionary = t.bindings, this._activations = t.activations, this._deactivations = t.deactivations, this._middleware = t.middleware, this._moduleActivationStore = t.moduleActivationStore;
  }, n.prototype.createChild = function(t) {
    var e = new n(t || this.options);
    return e.parent = this, e;
  }, n.prototype.applyMiddleware = function() {
    for (var t = [], e = 0; e < arguments.length; e++)
      t[e] = arguments[e];
    var r = this._middleware ? this._middleware : this._planAndResolve();
    this._middleware = t.reduce(function(i, a) {
      return a(i);
    }, r);
  }, n.prototype.applyCustomMetadataReader = function(t) {
    this._metadataReader = t;
  }, n.prototype.get = function(t) {
    var e = this._getNotAllArgs(t, !1);
    return this._getButThrowIfAsync(e);
  }, n.prototype.getAsync = function(t) {
    return B(this, void 0, void 0, function() {
      var e;
      return j(this, function(r) {
        return e = this._getNotAllArgs(t, !1), [2, this._get(e)];
      });
    });
  }, n.prototype.getTagged = function(t, e, r) {
    var i = this._getNotAllArgs(t, !1, e, r);
    return this._getButThrowIfAsync(i);
  }, n.prototype.getTaggedAsync = function(t, e, r) {
    return B(this, void 0, void 0, function() {
      var i;
      return j(this, function(a) {
        return i = this._getNotAllArgs(t, !1, e, r), [2, this._get(i)];
      });
    });
  }, n.prototype.getNamed = function(t, e) {
    return this.getTagged(t, L, e);
  }, n.prototype.getNamedAsync = function(t, e) {
    return this.getTaggedAsync(t, L, e);
  }, n.prototype.getAll = function(t) {
    var e = this._getAllArgs(t);
    return this._getButThrowIfAsync(e);
  }, n.prototype.getAllAsync = function(t) {
    var e = this._getAllArgs(t);
    return this._getAll(e);
  }, n.prototype.getAllTagged = function(t, e, r) {
    var i = this._getNotAllArgs(t, !0, e, r);
    return this._getButThrowIfAsync(i);
  }, n.prototype.getAllTaggedAsync = function(t, e, r) {
    var i = this._getNotAllArgs(t, !0, e, r);
    return this._getAll(i);
  }, n.prototype.getAllNamed = function(t, e) {
    return this.getAllTagged(t, L, e);
  }, n.prototype.getAllNamedAsync = function(t, e) {
    return this.getAllTaggedAsync(t, L, e);
  }, n.prototype.resolve = function(t) {
    var e = this.isBound(t);
    e || this.bind(t).toSelf();
    var r = this.get(t);
    return e || this.unbind(t), r;
  }, n.prototype._preDestroy = function(t, e) {
    var r, i;
    if (Reflect.hasMetadata(Dt, t)) {
      var a = Reflect.getMetadata(Dt, t);
      return (i = (r = e)[a.value]) === null || i === void 0 ? void 0 : i.call(r);
    }
  }, n.prototype._removeModuleHandlers = function(t) {
    var e = this._moduleActivationStore.remove(t);
    this._activations.removeIntersection(e.onActivations), this._deactivations.removeIntersection(e.onDeactivations);
  }, n.prototype._removeModuleBindings = function(t) {
    return this._bindingDictionary.removeByCondition(function(e) {
      return e.moduleId === t;
    });
  }, n.prototype._deactivate = function(t, e) {
    var r = this, i = Object.getPrototypeOf(e).constructor;
    try {
      if (this._deactivations.hasKey(t.serviceIdentifier)) {
        var a = this._deactivateContainer(e, this._deactivations.get(t.serviceIdentifier).values());
        if (k(a))
          return this._handleDeactivationError(a.then(function() {
            return r._propagateContainerDeactivationThenBindingAndPreDestroyAsync(t, e, i);
          }), i);
      }
      var s = this._propagateContainerDeactivationThenBindingAndPreDestroy(t, e, i);
      if (k(s))
        return this._handleDeactivationError(s, i);
    } catch (l) {
      if (l instanceof Error)
        throw new Error(St(i.name, l.message));
    }
  }, n.prototype._handleDeactivationError = function(t, e) {
    return B(this, void 0, void 0, function() {
      var r;
      return j(this, function(i) {
        switch (i.label) {
          case 0:
            return i.trys.push([0, 2, , 3]), [4, t];
          case 1:
            return i.sent(), [3, 3];
          case 2:
            if (r = i.sent(), r instanceof Error)
              throw new Error(St(e.name, r.message));
            return [3, 3];
          case 3:
            return [2];
        }
      });
    });
  }, n.prototype._deactivateContainer = function(t, e) {
    for (var r = this, i = e.next(); i.value; ) {
      var a = i.value(t);
      if (k(a))
        return a.then(function() {
          return r._deactivateContainerAsync(t, e);
        });
      i = e.next();
    }
  }, n.prototype._deactivateContainerAsync = function(t, e) {
    return B(this, void 0, void 0, function() {
      var r;
      return j(this, function(i) {
        switch (i.label) {
          case 0:
            r = e.next(), i.label = 1;
          case 1:
            return r.value ? [4, r.value(t)] : [3, 3];
          case 2:
            return i.sent(), r = e.next(), [3, 1];
          case 3:
            return [2];
        }
      });
    });
  }, n.prototype._getContainerModuleHelpersFactory = function() {
    var t = this, e = function(h, _) {
      h._binding.moduleId = _;
    }, r = function(h) {
      return function(_) {
        var S = t.bind(_);
        return e(S, h), S;
      };
    }, i = function() {
      return function(h) {
        return t.unbind(h);
      };
    }, a = function() {
      return function(h) {
        return t.unbindAsync(h);
      };
    }, s = function() {
      return function(h) {
        return t.isBound(h);
      };
    }, l = function(h) {
      return function(_) {
        var S = t.rebind(_);
        return e(S, h), S;
      };
    }, d = function(h) {
      return function(_, S) {
        t._moduleActivationStore.addActivation(h, _, S), t.onActivation(_, S);
      };
    }, o = function(h) {
      return function(_, S) {
        t._moduleActivationStore.addDeactivation(h, _, S), t.onDeactivation(_, S);
      };
    };
    return function(h) {
      return {
        bindFunction: r(h),
        isboundFunction: s(),
        onActivationFunction: d(h),
        onDeactivationFunction: o(h),
        rebindFunction: l(h),
        unbindFunction: i(),
        unbindAsyncFunction: a()
      };
    };
  }, n.prototype._getAll = function(t) {
    return Promise.all(this._get(t));
  }, n.prototype._get = function(t) {
    var e = ht(ht({}, t), { contextInterceptor: function(i) {
      return i;
    }, targetType: rt.Variable });
    if (this._middleware) {
      var r = this._middleware(e);
      if (r == null)
        throw new Error(Mn);
      return r;
    }
    return this._planAndResolve()(e);
  }, n.prototype._getButThrowIfAsync = function(t) {
    var e = this._get(t);
    if (De(e))
      throw new Error(En(t.serviceIdentifier));
    return e;
  }, n.prototype._getAllArgs = function(t) {
    var e = {
      avoidConstraints: !0,
      isMultiInject: !0,
      serviceIdentifier: t
    };
    return e;
  }, n.prototype._getNotAllArgs = function(t, e, r, i) {
    var a = {
      avoidConstraints: !1,
      isMultiInject: e,
      serviceIdentifier: t,
      key: r,
      value: i
    };
    return a;
  }, n.prototype._planAndResolve = function() {
    var t = this;
    return function(e) {
      var r = er(t._metadataReader, t, e.isMultiInject, e.targetType, e.serviceIdentifier, e.key, e.value, e.avoidConstraints);
      r = e.contextInterceptor(r);
      var i = Or(r);
      return i;
    };
  }, n.prototype._deactivateIfSingleton = function(t) {
    var e = this;
    if (t.activated)
      return k(t.cache) ? t.cache.then(function(r) {
        return e._deactivate(t, r);
      }) : this._deactivate(t, t.cache);
  }, n.prototype._deactivateSingletons = function(t) {
    for (var e = 0, r = t; e < r.length; e++) {
      var i = r[e], a = this._deactivateIfSingleton(i);
      if (k(a))
        throw new Error(kn);
    }
  }, n.prototype._deactivateSingletonsAsync = function(t) {
    return B(this, void 0, void 0, function() {
      var e = this;
      return j(this, function(r) {
        switch (r.label) {
          case 0:
            return [4, Promise.all(t.map(function(i) {
              return e._deactivateIfSingleton(i);
            }))];
          case 1:
            return r.sent(), [2];
        }
      });
    });
  }, n.prototype._propagateContainerDeactivationThenBindingAndPreDestroy = function(t, e, r) {
    return this.parent ? this._deactivate.bind(this.parent)(t, e) : this._bindingDeactivationAndPreDestroy(t, e, r);
  }, n.prototype._propagateContainerDeactivationThenBindingAndPreDestroyAsync = function(t, e, r) {
    return B(this, void 0, void 0, function() {
      return j(this, function(i) {
        switch (i.label) {
          case 0:
            return this.parent ? [4, this._deactivate.bind(this.parent)(t, e)] : [3, 2];
          case 1:
            return i.sent(), [3, 4];
          case 2:
            return [4, this._bindingDeactivationAndPreDestroyAsync(t, e, r)];
          case 3:
            i.sent(), i.label = 4;
          case 4:
            return [2];
        }
      });
    });
  }, n.prototype._removeServiceFromDictionary = function(t) {
    try {
      this._bindingDictionary.remove(t);
    } catch {
      throw new Error(bn + " " + et(t));
    }
  }, n.prototype._bindingDeactivationAndPreDestroy = function(t, e, r) {
    var i = this;
    if (typeof t.onDeactivation == "function") {
      var a = t.onDeactivation(e);
      if (k(a))
        return a.then(function() {
          return i._preDestroy(r, e);
        });
    }
    return this._preDestroy(r, e);
  }, n.prototype._bindingDeactivationAndPreDestroyAsync = function(t, e, r) {
    return B(this, void 0, void 0, function() {
      return j(this, function(i) {
        switch (i.label) {
          case 0:
            return typeof t.onDeactivation != "function" ? [3, 2] : [4, t.onDeactivation(e)];
          case 1:
            i.sent(), i.label = 2;
          case 2:
            return [4, this._preDestroy(r, e)];
          case 3:
            return i.sent(), [2];
        }
      });
    });
  }, n;
}();
function xt() {
  return function(n) {
    if (Reflect.hasOwnMetadata(At, n))
      throw new Error(_n);
    var t = Reflect.getMetadata(pn, n) || [];
    return Reflect.defineMetadata(At, t, n), n;
  };
}
const dt = {
  DebugLogger: Symbol("DebugLogger")
};
class Ce {
  /**
   * @param container - Inversify container instance.
   * @param name - Name of the item being registered (e.g. Analytics).  This is used for logging registration information.
   */
  constructor(t, e) {
    Y(this, "container");
    Y(this, "serviceName");
    this.container = t, this.serviceName = e;
  }
  register() {
    const t = bt.isProductionEnvironment(), e = bt.isTestEnvironment();
    let r;
    t ? r = this.registerProduction() : e ? r = this.registerTest() : r = this.registerDebug(), e || console.log(
      "[mchs] REGISTRATION -> " + this.serviceName + ": " + r
    );
  }
}
var jr = Object.defineProperty, Lr = Object.getOwnPropertyDescriptor, Ur = (n, t, e, r) => {
  for (var i = r > 1 ? void 0 : r ? Lr(t, e) : t, a = n.length - 1, s; a >= 0; a--)
    (s = n[a]) && (i = (r ? s(t, e, i) : s(i)) || i);
  return r && i && jr(t, e, i), i;
};
let Tt = class {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  log(n, t, ...e) {
    const r = `[mchs] ${n.length > 0 ? `${n.toUpperCase()} -> ` : ""}${t}`;
    e.length > 0 ? console.log(r, ...e) : console.log(r);
  }
};
Tt = Ur([
  xt()
], Tt);
const $r = Tt;
var Wr = Object.defineProperty, Vr = Object.getOwnPropertyDescriptor, Gr = (n, t, e, r) => {
  for (var i = r > 1 ? void 0 : r ? Vr(t, e) : t, a = n.length - 1, s; a >= 0; a--)
    (s = n[a]) && (i = (r ? s(t, e, i) : s(i)) || i);
  return r && i && Wr(t, e, i), i;
};
let It = class {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
  log(n, t, ...e) {
  }
};
It = Gr([
  xt()
], It);
const Yr = It;
class Hr extends Ce {
  constructor(t) {
    super(t, "Debug Logger");
  }
  registerProduction() {
    return this.registerIgnore();
  }
  registerTest() {
    return this.registerIgnore();
  }
  registerDebug() {
    return this.registerConsole();
  }
  registerConsole() {
    return this.container.bind(dt.DebugLogger).to($r), "Console";
  }
  registerIgnore() {
    return this.container.bind(dt.DebugLogger).to(Yr), "Ignore";
  }
}
function Kr() {
  return Ee(dt.DebugLogger);
}
function vi() {
  return Ne(dt.DebugLogger);
}
const Ft = {
  DiagnosticsService: Symbol("DiagnosticsService")
};
var zr = Object.defineProperty, Jr = Object.getOwnPropertyDescriptor, Zr = (n, t, e, r) => {
  for (var i = r > 1 ? void 0 : r ? Jr(t, e) : t, a = n.length - 1, s; a >= 0; a--)
    (s = n[a]) && (i = (r ? s(t, e, i) : s(i)) || i);
  return r && i && zr(t, e, i), i;
};
let Mt = class {
  logError(n, t) {
    console.log(`[mchs] DIAGNOSTICS -> (${n}): ${t}`);
  }
};
Mt = Zr([
  xt()
], Mt);
const qr = Mt;
class Qr extends Ce {
  constructor(t) {
    super(t, "Diagnostics Service");
  }
  registerProduction() {
    return this.registerConsole();
  }
  registerTest() {
    return this.registerConsole();
  }
  registerDebug() {
    return this.registerConsole();
  }
  registerConsole() {
    return this.container.bind(Ft.DiagnosticsService).to(qr), "Console";
  }
}
function pi() {
  return Ee(Ft.DiagnosticsService);
}
function gi() {
  return Ne(
    Ft.DiagnosticsService
  );
}
const Ct = new Br(), Xr = Array(
  new Hr(Ct),
  new Qr(Ct)
);
Xr.forEach((n) => {
  n.register();
});
function Ee(n) {
  return Ct.get(n);
}
const Oe = cn({
  container: null
}), yi = (n) => /* @__PURE__ */ ln(Oe.Provider, { value: { container: n.container }, children: n.children });
function Ne(n) {
  const { container: t } = fn(Oe);
  if (!t)
    throw console.log("[mchs] IOC -> No container exists."), new Error();
  return t.get(n);
}
class ti {
  formatAddress(t, e, r, i) {
    let a = "";
    return e && (a += e), r && (a.length > 0 && (a += " "), a += r), i && (a.length > 0 && (a += " "), a += i), t && (a.length > 0 && (a += " "), a += t), a;
  }
}
const mi = new ti();
class ei {
  constructor() {
    Y(this, "maxDate", /* @__PURE__ */ new Date(864e13));
    Y(this, "minDate", /* @__PURE__ */ new Date(-864e13));
  }
  /** ex. Thursday, September 24, 2020 */
  formatDateLongWeekdayLongMonth(t) {
    const e = {
      weekday: "long",
      month: "long",
      day: "numeric",
      year: "numeric"
    };
    return Intl.DateTimeFormat("en-US", e).format(new Date(t));
  }
  /** ex. March */
  formatDateLongMonthOnly(t) {
    const e = {
      month: "long"
    };
    return Intl.DateTimeFormat("en-US", e).format(new Date(t));
  }
  /** ex. March 2020 */
  formatDateLongMonthYear(t) {
    const e = {
      month: "long",
      year: "numeric"
    };
    return Intl.DateTimeFormat("en-US", e).format(new Date(t));
  }
  /** ex. March 3, 2020 */
  formatDateLongMonth(t) {
    const e = {
      month: "long",
      day: "numeric",
      year: "numeric"
    };
    return Intl.DateTimeFormat("en-US", e).format(new Date(t));
  }
  /** ex. Mar 3, 2020 */
  formatDateShortMonth(t) {
    const e = {
      month: "short",
      day: "numeric",
      year: "numeric"
    };
    return Intl.DateTimeFormat("en-US", e).format(new Date(t));
  }
  /** ex. Mar 3 */
  formatDateShortMonthNoYear(t) {
    const e = {
      month: "short",
      day: "numeric"
    };
    return Intl.DateTimeFormat("en-US", e).format(new Date(t));
  }
  /** ex. Mar 3, 2020 at 8:00 AM*/
  formatDateShortMonthAtTime(t) {
    return `${this.formatDateShortMonth(t)} at ${this.formatTime(t)}`;
  }
  /** ex. March 3, 2020 at 8:00 AM*/
  formatDateLongMonthAtTime(t) {
    return `${this.formatDateLongMonth(t)} at ${this.formatTime(t)}`;
  }
  formatDayDateLongMonthAtTime(t) {
    return `${this.getDay(t)}, ${this.formatDateLongMonth(
      t
    )} at ${this.formatTime(t)}`;
  }
  /** ex. 03/03/2020 */
  formatDateTwoDigitDayMonth(t) {
    const e = {
      month: "2-digit",
      day: "2-digit",
      year: "numeric"
    };
    return Intl.DateTimeFormat("en-US", e).format(
      new Date(t.getTime())
    );
  }
  /** ex. 03/03/2020 13:00 */
  formatDateTimeTwoDigitDayMonth(t) {
    const e = {
      month: "2-digit",
      day: "2-digit",
      year: "numeric"
    }, r = {
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: !1
    }, i = Intl.DateTimeFormat("en-US", e).format(
      new Date(t.getTime())
    );
    let a = Intl.DateTimeFormat("en-US", r).format(
      new Date(t.getTime())
    );
    return a = a.replace("24:00:00", "00:00:00"), `${i} ${a}`;
  }
  /** ex. 03/03/2020 */
  formatDateYearMonthDay(t) {
    const e = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    };
    return Intl.DateTimeFormat("en-US", e).format(
      new Date(t.getTime())
    );
  }
  /** ex. 3rd of March */
  formatDateDayOfMonth(t) {
    var o, h;
    const e = {
      month: "long",
      day: "numeric"
    }, r = Intl.DateTimeFormat("en-US", e).formatToParts(
      new Date(t)
    ), i = new Intl.PluralRules("en-US", { type: "ordinal" }), a = /* @__PURE__ */ new Map([
      ["one", "st"],
      ["two", "nd"],
      ["few", "rd"],
      ["other", "th"]
    ]), l = ((_) => {
      const S = i.select(_), N = a.get(S);
      return `${_}${N}`;
    })(
      Number((o = r.find((_) => _.type === "day")) == null ? void 0 : o.value)
    ), d = (h = r.find((_) => _.type === "month")) == null ? void 0 : h.value;
    return `${l} of ${d}`;
  }
  /**  ex. 2020 */
  formatDateFullYear(t) {
    return `${t.getFullYear()}`;
  }
  getDay(t) {
    return [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ][t.getDay()];
  }
  /** ex. Thursday, September 24, 2020 at 8:00 AM */
  formatDateLongWeekdayLongMonthAtTime(t) {
    return `${this.formatDateLongWeekdayLongMonth(t)} at ${this.formatTime(
      t
    )}`;
  }
  /** ex. 2020-01 */
  formatDateISOYearMonth(t) {
    const e = t.getFullYear(), r = t.getMonth() + 1;
    let i = r.toString();
    return r < 10 && (i = `0${r}`), `${e}-${i}`;
  }
  /** ex. 2020-01-01 */
  formatDateISOYearMonthDay(t) {
    const e = t.getFullYear(), r = t.getMonth() + 1, i = t.getDate();
    let a = r.toString();
    r < 10 && (a = `0${r}`);
    let s = i.toString();
    return i < 10 && (s = `0${i}`), `${e}-${a}-${s}`;
  }
  /** ex. 01-23-1996 */
  formatDateISOMonthDayYear(t) {
    const e = t.getFullYear(), r = t.getMonth() + 1, i = t.getDate();
    let a = r.toString();
    r < 10 && (a = `0${r}`);
    let s = i.toString();
    return i < 10 && (s = `0${i}`), `${a}-${s}-${e}`;
  }
  /** ex. 2023-09-26T09:49:23-05:00 */
  formatDateISOWithTimeZone(t) {
    const e = -t.getTimezoneOffset(), r = e >= 0 ? "+" : "-", i = (a) => `${Math.floor(Math.abs(a))}`.padStart(2, "0");
    return t.getFullYear() + "-" + i(t.getMonth() + 1) + "-" + i(t.getDate()) + "T" + i(t.getHours()) + ":" + i(t.getMinutes()) + ":" + i(t.getSeconds()) + r + i(e / 60) + ":" + i(e % 60);
  }
  /** ex. 2020-01-01 */
  parseDateISOYearMonthDay(t) {
    const e = t.split("-");
    return new Date(
      parseInt(e[0]),
      parseInt(e[1]) - 1,
      parseInt(e[2])
    );
  }
  /** ex. 2020-01-01T10:30:00-05:00 */
  parseDateISOYearMonthDayTime(t) {
    const e = t.split("T"), r = e[0].split("-"), i = e[1].split("-")[0].split(":");
    return new Date(
      parseInt(r[0]),
      parseInt(r[1]) - 1,
      parseInt(r[2]),
      parseInt(i[0]),
      parseInt(i[1]),
      parseInt(i[2])
    );
  }
  formatTimeFromDateTimeStrings(t, e, r = !1) {
    return this.formatTime(/* @__PURE__ */ new Date(`${t}T${e}`), r);
  }
  /** ex. 12:15 PM. stripMinutes will remove :00 if true */
  formatTime(t, e = !1) {
    const r = {
      hour: "numeric",
      minute: "numeric"
    }, i = new Date(t);
    let a = Intl.DateTimeFormat("en-US", r).format(i);
    if (e) {
      const s = a.split(" "), l = s[0].split(":");
      l[l.length - 1] === "00" && (a = `${l[0]} ${s[s.length - 1]}`);
    }
    return a;
  }
  formatMessagingDate(t) {
    const e = /* @__PURE__ */ new Date();
    return e.getFullYear() === t.getFullYear() && e.getMonth() === t.getMonth() && e.getDate() === t.getDate() ? this.formatTime(t) : t.getFullYear() < e.getFullYear() ? this.formatDateYearMonthDay(t) : this.formatDateShortMonthNoYear(t);
  }
  /** ex. 1/1/2020 */
  getDateFromCattailsDateString(t) {
    const e = t.split("/");
    return new Date(
      parseInt(e[2]),
      parseInt(e[0]) - 1,
      parseInt(e[1])
    );
  }
  /** ex. 1/1/2020 */
  getDateNullableFromCattailsDateString(t) {
    if (t !== null)
      return this.getDateFromCattailsDateString(t);
  }
  /** ex. 4:00 PM */
  getDateFromCattailsTimeString(t) {
    let e = 0, r;
    if (t.length > 5) {
      const i = t.match(/PM/);
      r = t.substring(0, t.length - 3).split(":"), e = parseInt(r[0]), i && e !== 12 ? e += 12 : !i && e === 12 && (e = 0);
    } else
      r = t.split(":"), e = parseInt(r[0]);
    return new Date(9999, 12, 12, e, parseInt(r[1]));
  }
  /** ex. date = '1/1/2020'  time = '4:00 PM' */
  getDateFromCattailsDateTimeString(t, e) {
    const r = this.getDateFromCattailsDateString(t);
    if (!r)
      throw new Error("Invalid Date");
    const i = this.getDateFromCattailsTimeString(e);
    if (!i)
      throw new Error("Invalid Time");
    return new Date(
      r.getFullYear(),
      r.getMonth(),
      r.getDate(),
      i.getHours(),
      i.getMinutes()
    );
  }
  getDateFromCattailsSingleDateTimeString(t) {
    const e = t.indexOf(" "), r = t.substring(0, e), i = t.substring(
      e + 1,
      t.length
    );
    return this.getDateFromCattailsDateTimeString(r, i);
  }
  /** ex. Thursday */
  formatDateDayOfWeek(t) {
    return t.toLocaleDateString("en-US", { weekday: "long" });
  }
  getUtcDateTime(t) {
    return new Date(
      t.getUTCFullYear(),
      t.getUTCMonth(),
      t.getUTCDate(),
      t.getUTCHours(),
      t.getUTCMinutes(),
      t.getUTCSeconds()
    );
  }
  getCurrentUtcDateTime() {
    const t = /* @__PURE__ */ new Date();
    return new Date(
      t.getUTCFullYear(),
      t.getUTCMonth(),
      t.getUTCDate(),
      t.getUTCHours(),
      t.getUTCMinutes(),
      t.getUTCSeconds()
    );
  }
  isDateBeforeToday(t) {
    return new Date(t.toDateString()) < new Date((/* @__PURE__ */ new Date()).toDateString());
  }
  formatHoursRange(t, e, r, i) {
    return i ? "Closed" : `${this.formatTimeFromDateTimeStrings(
      t,
      e,
      !1
    )} - ${this.formatTimeFromDateTimeStrings(t, r, !1)}`;
  }
  /* todayHours should be formatted like: "10:30 AM - 3:30 PM"*/
  isCurrentTimeBetween(t) {
    if (t) {
      const e = this.formatTime(/* @__PURE__ */ new Date(), !1), r = parseInt(e);
      let i = 0, a = "";
      r > 9 ? (i = parseInt(e.substring(3, 5)), a = e.substring(6)) : (i = parseInt(e.substring(2, 4)), a = e.substring(5));
      const s = t.split("-"), l = s[0], d = s[1], o = l.split(":"), h = d.split(":"), _ = parseInt(o[0]), S = parseInt(o[1]), N = o[1].substring(3, 5), x = parseInt(h[0]), F = parseInt(h[1]), W = h[1].substring(3, 5);
      return !!(!this.isBeforeTime(
        r,
        i,
        a,
        _,
        S,
        N
      ) && this.isBeforeTime(
        r,
        i,
        a,
        x,
        F,
        W
      ));
    }
    return !1;
  }
  isBeforeTime(t, e, r, i, a, s) {
    return r === s ? t === 12 && i !== 12 ? !0 : t !== 12 && i === 12 ? !1 : t === 12 && i === 12 ? e < a ? !0 : !(e > a) : t < i ? !0 : t > i ? !1 : e < a ? !0 : !(e > a) : r === "AM" && s === "PM";
  }
  getDateFromYYYYMMDDString(t) {
    const e = parseInt(t.substring(0, 4)), r = parseInt(t.substring(4, 6)), i = parseInt(t.substring(6, 8));
    return new Date(e, r - 1, i);
  }
  getDateFromMM_DD_YYYYString(t) {
    const e = parseInt(t.substring(6, 10)), r = parseInt(t.substring(0, 2)), i = parseInt(t.substring(3, 5));
    return new Date(e, r - 1, i);
  }
  getDateWithoutTime(t) {
    return new Date(t.getFullYear(), t.getMonth(), t.getDate());
  }
  isDayInList(t, e) {
    const r = new Array(), i = t.getDay();
    return e.forEach((a) => {
      a === "Monday" && r.push(1), a === "Tuesday" && r.push(2), a === "Wednesday" && r.push(3), a === "Thursday" && r.push(4), a === "Friday" && r.push(5);
    }), r.find((a) => a === i) !== void 0;
  }
  isDateStringValid(t, e) {
    return (e === void 0 || e === !1) && (t === void 0 || t.length === 0) ? !0 : t.match(/^\d{2}\/\d{2}\/\d{4}$/) !== null;
  }
}
const _i = new ei();
class ni {
  constructor() {
    Y(this, "isValid", (t) => t.match(/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/) !== null);
  }
}
const wi = new ni();
class ri {
  wrapSourceWithUrl(t) {
    return `url("${t}")`;
  }
}
const bi = new ri();
class ii {
  formatPhoneNumber(t) {
    const e = t ?? "", r = e.length > 2 ? `(${e.substring(0, 3)})` : e, i = e.length > 3 ? ` ${e.substring(3, 6)}` : "", a = e.length > 6 ? `-${e.substring(6, 10)}` : "";
    return `${r}${i}${a}`;
  }
  cleanPhone(t) {
    let e = t.replace(/\D/g, "");
    return e.length > 10 && (e = e.substring(
      e.length - 10
    )), e;
  }
  callPhone(t) {
    document.location.href = `tel:${t}`;
  }
}
const Ai = new ii();
class ai {
  constructor() {
    Y(this, "debugLogger", Kr());
  }
  async sleepAsync(t) {
    return this.debugLogger.log("SleepUtility", `Sleeping ${t} milliseconds....`), new Promise(
      (e) => setTimeout(() => {
        e();
      }, t)
    );
  }
}
const Di = new ai();
class oi {
  sortByField(t, e) {
    const r = function(a) {
      return a[t];
    }, i = e ? 1 : -1;
    return function(a, s) {
      return a = r(a), s = r(s), i * ((a > s ? 1 : 0) - (s > a ? 1 : 0));
    };
  }
  sortItems(t, e, r) {
    if (t == null)
      return [];
    let i = [...t];
    return i = i.sort(this.sortByField(e, r)), i;
  }
}
const Si = new oi();
export {
  mi as AddressUtility,
  dt as DEBUG_LOGGER_TYPES,
  Ft as DIAGNOSTICS_SERVICE_TYPES,
  _i as DateUtility,
  Hr as DebugLoggerRegistration,
  Qr as DiagnosticsServiceRegistration,
  wi as EmailUtility,
  bt as Environment,
  bi as ImageUtility,
  Oe as InversifyContext,
  yi as IocProvider,
  Ce as IocRegistration,
  Ai as PhoneUtility,
  Di as SleepUtility,
  Si as SortUtility,
  Ct as container,
  Kr as getDebugService,
  pi as getDiagnosticsService,
  Ee as getService,
  vi as useDebugLogger,
  gi as useDiagnosticsService,
  Ne as useInjection,
  fi as useKeyPress,
  li as useOutsideAlerter,
  hi as useScreenSize,
  di as useToggle
};
